const { APP_NAME, SHORT_DOMAIN, APP_HOST } = window.ThrowdownsConfig;
const year = (new Date()).getFullYear();

export default {
  key: 'pt',
  name: 'Português',
  messages: {
    email: 'Email',
    ticket: 'Ticket',
    ticketId: 'Ticket ID',
    lastScan: 'Last Redeemed',
    totalScans: 'Total Redemptions',
    buyTickets: 'Buy Tickets',
    specTickets: 'Spectator Tickets',
    yourTickets: 'Your Tickets',
    print: 'Print',
    buyMoreTickets: 'Buy More Tickets',
    ticketSalesClosedHeader: 'Ticket Sales Closed',
    ticketSalesClosedText: 'Tickets are not currently on sale.',
    loginToBuyTickets: 'Login to buy tickets',
    viewTickets: 'View Tickets',
    buyTicketsToday: 'Buy Tickets Today!',
    tickets: 'Tickets',
    ticketsPanelHeading: 'Tickets',
    ticketsAddingItem: 'Adding Ticket',
    ticketsAddItemButton: 'Add Ticket',
    ticketItemName: 'Ticket Name',
    ticketItemNameDescr:
      'The name of the class of ticket you want to sell (e.g. VIP, Regular, Student)',
    ticketDescriptionDescr: 'A brief description of this class of ticket',
    ticketDescriptionName: 'Ticket Description',
    ticketSalesOpen: 'Open Date for Ticket Sales',
    ticketSalesClose: 'Close Date for Ticket Sales',
    ticketingContent: 'Ticketing Content',
    ticketingContentLead:
      'This content is displayed at the top of your ticket sales page.',
    fieldTypeChoiceFreeResponseOneLine: 'Resposta Gratuita - Uma Linha',
    fieldTypeChoiceFreeResponseBox: 'Resposta Gratuita - Caixa',
    fieldTypeChoiceMultipleChoicePickOne: 'Múltipla Escolha - Escolha um',
    fieldTypeChoiceMultipleChoicePickOneDropdown:
      'Múltipla Escolha - Escolha um (Menu suspenso)',
    fieldTypeChoiceMultipleChoiceCanSelectMultipleAnswers:
      'Múltipla Escolha - Você pode responder mais de uma resposta',
    pointsTable200Points: '200 Pontos',
    pointsTable100Points: '100 Pontos',
    pointsTable50Points: '50 Pontos',
    pointsTableCustomPoints: 'Pontos Customizados',
    HigherisBetter: 'Quanto Mais Alto, Melhor',
    LowerisBetter: 'Quanto Mais Baixo, Melhor',
    tiePolicyTiesStand: 'Estande de Empates (Pontos Máximos)',
    tiePolicyTiesStandAverage: 'Ties Stand (Pontos Médios)',
    tiePolicyHigherisBetter: 'Quanto Mais Alto, Melhor',
    tiePolicyLowerisBetter: 'Quanto Mais Baixo, Melhor',
    scoringPolicyPlacement: 'Colocação',
    scoringPolicyMaxPoints: 'Pontos Máximo',
    scoringPolicyMinPoints: 'Pontos Mínimos',
    scoringPolicyPointsTable: 'Tabela de Pontos',
    pointsTableLabelCustom: 'Customizado',
    rank: 'Classificação',
    leaderboardNameColumnHeader: 'Atleta / Equipe',
    scorer: 'Pontuador',
    yes: 'Sim',
    no: 'Não',
    cancel: 'Cancelar',
    dashboard: 'Painel',
    manage: 'Gerenciar',
    preview: 'Anterior',
    registered: 'Registrado',
    submitScores: 'Enviar Pontuação',
    yourCompetitions: 'Suas Competições',
    addCompetition: 'Adicionar Competição',
    duplicate: 'Duplicar',
    setup: 'Configuração',
    programming: 'Programação',
    programmingComplete: 'Programming Complete',
    registration: 'Registro',
    registrationComplete: 'Registration Complete',
    payments: 'Pagamentos',
    paymentsComplete: 'Payments Complete',
    published: 'Publicado',
    publish: 'Publicar',
    requested: 'Solicitado',
    request: 'Solicitar',
    inProgress: 'Em andamento',
    login: 'Login',
    location: 'Localização',
    getDirections: 'Obter Direções',
    date: 'Data',
    description: 'Descrição',
    addScores: 'Adicionar Pontos',
    view: 'Visualizar',
    register: 'Registrar',
    now: 'Agora',
    closed: 'Fechado',
    leaderboards: 'Placar',
    organizedBy: 'Organizado por',
    contactTheOrganizer: 'Contatar o Organizador',
    getDrivingDirections: 'Obter Direções de Condução',
    workout: 'Treino',
    workouts: 'Treinos',
    division: 'Divisão',
    divisions: 'Divisões',
    shareWithFriends: 'Compartilhar com Amigos',
    athleteRegistration: 'Registro',
    tryAgain: 'Tentar Novamente',
    youreRegistered: 'Você está registrado',
    edit: 'Editar',
    youAreRegConfirm: `Atualize seu <strong><a href='${APP_HOST}/app/my-account/profile' Perfil do atleta</a></strong>`,
    charges: 'Cobranças',
    card: 'Cartão',
    registrationFee: 'Taxa de Registro',
    appliedCouponCode: 'Aplicado <code>{code}</code>',
    processingFee: 'Taxa de Processamento',
    charge: 'Cobrança',
    registerToday: 'Registre Hoje',
    loginToRegister: 'Para se registrar numa competição, você vai precisar de',
    loginLower: 'login',
    dontHaveAccount: 'Não tem uma conta?',
    createOne: 'Criar uma',
    inUnderAMinute: 'em menos de um minuto',
    alreadyRecorded:
      'Você já tem pontos registrados. Mudanças não são permitidas no seu registro.',
    calculatingTotal: 'Calculando o Total',
    discount: 'Desconto',
    feeBalance: 'Saldo de Taxa',
    totalCharge: 'Cobrança Total',
    readAndAccept: 'Eu li e aceitei o acordo.',
    readAndAcceptCompt: 'Eu li e aceitei o acordo de {competitionTitle} .',
    updateRegistration: 'Atualizar Registro',
    calculateTotal: 'Calcular Total',
    submitting: 'Enviar',
    allDivisionsAreFull: 'Todas as divisões estão cheias',
    whatDivision: 'Em qual divisão você quer se registrar?',
    leaderboardName: 'Nome do Placar',
    leaderboardDescription: 'O nome que você quer que apareça no placar',
    memberFormHeading: 'Membro da Equipe {memberIndex} / {registrants}',
    registrantName: 'Nome do Inscrito',
    registratDescription: 'Nome do Atleta',
    registrantFirstNameDescription: 'Athlete first Name',
    registrantLastNameDescription: 'Athlete last Name',
    registrantEmail: 'Endereço de email do inscrito',
    registrantEmailDescription: 'Endereço de email do atleta',
    coupon: 'Cupom',
    couponIsValid: 'O cupom é válido',
    couponIsInValid: 'O cupom é inválido',
    enterCoupon: 'Insira o código do cupom',
    helpfulLinks: 'Links úteis',
    Leaderboards: 'Como entender o Placar',
    privacyTerms: 'Termos e Privacidade',
    throwdownsBlog: `Blog do ${APP_NAME}`,
    copyright: `© 2014-${year} - ${SHORT_DOMAIN} Todos os direitos reservados`,
    rotateLeaderboards: 'Alternar o Placar',
    filterAthletes: 'Filtrar os Atletas',
    athleteName: 'Nome dos Atletas',
    noLeaderboard: 'Nenhum placar foi registrado ainda',
    loading: 'Carregando',
    points: 'Pontos',
    switchDivisions: 'Trocar divisões',
    needPassword: 'Você precisa de uma senha para poder fazer o login de volta',
    setPassword: 'Configurar senha',
    title: 'Título',
    startDate: 'Data de Início',
    endDate: 'Data final',
    venueName: 'Nome do Local',
    creatingCompetition: 'Criando uma competição',
    beginSetup: 'Iniciar configuração',
    finishSetupComp: 'Finalizar e configurar a competição',
    continue: 'Continuar',
    setupWelcomeIntro: `Estamos felizes que você está interessado nos ${APP_NAME}!`,
    setupWelcomeMain:
      'Vamos começar a configurar sua primeira competição. Responda algumas perguntas para começar!',
    setupName: 'Qual é o nome da sua competição?',
    myCompetitionName: 'Nome da minha competição',
    setupKindOnline: 'A <span class="comp-name">{compName}</span> é uma competição online?',
    setupKindOnlineDescr:
      'Uma competição online é onde os atletas competem e enviam os pontos online de qualquer lugar do mundo ao invés de ter juízes locais',
    goBack: 'Voltar',
    whereCompLoc:
      'Onde acontecerá a <span class=\'comp-name\'>{compName}</span> ?',
    venueAddress: 'Endereço do Local',
    setupCompDate: 'Onde acontecerá o <span class="comp-name">{compName}</span> ?',
    timeZoneDescr:
      'O fuso-horário para os horáriso das suas competições publicadas',
    timeZoneDescrLabel: 'Fuso-horário',
    start: 'Início',
    end: 'Fim',
    setupLastStep: 'Último passo! Só mais uma coisa!',
    setupUploadCoverPhoto: 'Carregue uma foto de capa para <span class="comp-name">{compName}</span>',
    suggestedDim: 'Dimensões Sugeridas: {width}x{height}',
    dragOrClickPhoto: 'Arraste a foto ou Clique para carregar',
    finishCropping: 'Finalizar o corte',
    imageWarning: 'Sua imagem é menor do que as dimensões recomendadas e provavelmente ficará embassada. Recomendamos no mínimo a resolução {recommendedWidth}x{recommendedHeight} e sua imagem é de {width}x{height}.',
    selectDate: 'Selecionar data',
    setupCongrats: 'Parabéns! Você configurou uma competição com sucesso!',
    setupQuickSteps:
      'Sua página inicial está pronta! Somente alguns passos e sua competição será lançada...',
    launch: 'Lançar',
    marketingSetupTitlePage: 'O título da sua página',
    marketingSetupCompName: 'Nome da Competição',
    marketingSetupCompEmail: 'E-mail de contato',
    marketingSetupCompEmailDesc:
      'O contato de e-mail primário para essa competição',
    marketingSetupShortlinkDescr: 'O slug da URL da sua competição',
    marketingSetupShortlinkTitle: 'ID do Encurtamento de URL',
    marketingSetupUpload: 'Carregar uma foto de capa',
    marketingSetupMobileUpload:
      'Carregar uma foto de capa para celular (opcional)',
    marketingSetupPicHelp:
      'Dimensão Sugerida: {width}x{height}. (Você pode girar/aumentar/diminuir/cortar depois de carregar)',
    marketingSetupOnlineDescr: 'Esta é uma competição online?',
    marketingSetupOnlineTitle: 'Competição online',
    invalidDate:
      'Não é válido para ter uma data final/horário anterior para começar.',
    programmingWelcome: 'Vamos configurar a programação para {compName}!',
    programmingWelcome2:
      'Vamos passar por seus treinos, divisões, e políticas de pontuação durante este processo de configuração.',
    programmmingDiv: 'Quais divisões você estará figurando?',
    programmmingEx:
      'Nós adicionamos alguns exemplos para você começar. Você deve arrastar e largar cada divisão para reorganizar suas posições na lista.',
    addDivision: 'Adicionar Divisão',
    dragDropDivision: 'Arrastar e largar divisões para mudar seu pedido.',
    teamSize: 'Tamanho da Equipe',
    teamSizeDescr: 'Deixe 1 se for uma divisão de apenas um atleta',
    maxRegistrations: 'Máximo de Registros',
    maxRegistrationsDescr:
      'Qual deveria ser o limite # de registros para esta divisão?',
    typeOfDivision: 'Tipo de Divisão',
    typeOfDivisionDescr:
      'Esta é uma divisão para atletas ou para gerenciar voluntários e espectadores?',
    athlete: 'Atleta',
    volunteer: 'Voluntários',
    spectator: 'Espectadores',
    nameOfDivision: 'O nome da divisão',
    divisionName: 'Nome da Divisão',
    loadingDivisions: 'Carregando Divisões',
    saving: 'Salvando...',
    save: 'Salvar',
    delete: 'Deletar',
    deleteAreYouSure: 'Tem certeza que gostaria de deletar',
    deleteFieldItemAreYouSure:
      'Are you sure you would like to delete this custom field? Any data collected by this question will be permanently lost.',
    deleting: 'Deletando...',
    programmingWorkouts: 'Quais treinos você estará apresentando?',
    programmingExamples:
      'Nós adicionamos alguns exemplos para você começar. Você deve arrastar e largar cada treino para reorganizar suas posições na lista.',
    addWorkout: 'Adicionar Treinos',
    dragDropWorkouts: 'Arrastar e largar os treinos para mudar suas posições.',
    workoutNameDescr: 'O nome do treino',
    workoutName: 'Nome do treino',
    loadingWorkouts: 'Carregando os treinos...',
    scoringPoliciesUsing: 'Qual tipo de política de pontuação você irá usar?',
    scoringLead:
      'Estas configurações determinarão como os treinos serão pontuados e serão usados para calcular a colocação dos atletas no placar.',
    dirtyChanges:
      'Você tem mudanças não salvas. Pressione continuar para salvar suas mudanças.',
    scoringType: 'Tipo de pontuação',
    scoringTypeDescr:
      'Selecione uma política de pontuação de placar para aplicar.',
    scoringOrder: 'Ordem de Pontuação',
    scoringOrderDescr:
      'Selecione a ordem de pontuação que deve estar no placar',
    tieBreakerPolicy: 'Política de desempate',
    tieBreakerPolicyDescr:
      'Selecione como o desempate deve acontecer no placar',
    pointsTablePolicy: 'Política de Tabela de Pontos',
    pointsTablePolicyDescr:
      'Selecione o número de pontos que devem ser usados para calcular a colocação do atleta',
    goYou: 'Vá você!',
    programmingConfigured: 'A programação para <span class="comp-name">{compName}</span> foi configurada com sucesso!',
    marketingContentTitle: 'Conteúdo da Página Inicial',
    marketingTimeVenueDescr: 'O nome do seu local',
    marketingTimeVenueTitle: 'Nome do local',
    marketingTimeAddressDescr: 'Comece a digitar o endereço da sua rua',
    marketingTimeAddressTitle: 'Endereço do local',
    marketingTimeZoneDescr: 'O fuso-horário da competição publicada',
    marketingTimeZoneTitle: 'Fuso-horário',
    marketingOnlineHeader: 'Pontuação Online',
    marketingOnlineSubHeader:
      'Controle como os envios de pontuação serão feitas para esta competição.',
    marketingOnlineWorkouts: 'Treinos',
    marketingOnlineInstr: 'Instruções para o Envio de Pontuação',
    marketingOnlineVideoTitle: 'Link do Video',
    marketingOnlineVideoDescr:
      'É necessário que o atleta envie um link para um video de seus treinos?',
    marketingOnlineImageTitle: 'Imagem',
    marketingOnlineImageDescr:
      'O atleta é obrigado a enviar uma imagem de seu treino?',
    marketingOnlineJudgeTitle: 'Juíza',
    marketingOnlineJudgeDescr:
      'O atleta é obrigado a enviar o nome da pessoa que julgou seu treino?',
    marketingOnlineScoreOpens: 'Pontuação aberta',
    marketingOnlineScoreCloses: 'Pontuação fechada',
    optional: 'Opcional',
    required: 'Requerido (será necessário fornecer para enviar a pontuação)',
    notOption: 'Não é uma opção (não mostrará entrada)',
    registrationConfig: 'Vamos configurar o registro para {compName}!',
    registrationSecondary:
      'Vamos passar por suas divisões, datas, taxas e conteúdos durante este processo de configuração.',
    finish: 'Terminar',
    registrationWhen: 'Quando o registro deve começar e terminar?',
    registrationAvail:
      'Selecione quando o registro para o seu evento estará disponível.',
    registrationOpens: 'Registro Aberto',
    registrationCloses: 'Registro Fechado',
    registrationCost: 'Quanto custa para registrar?',
    registrationFeesSet:
      'Taxa de Registro pode ser configurado individualmente por divisão.',
    preferredCurrency: 'Moeda de preferência',
    preferredCurrencyHelp:
      'Sua moeda de preferência para transações. **Estas moedas não contemplam o uso de AMEX.',
    divisionRegistrationFees: 'Taxas de registro da divisão',
    registrationContentMain:
      'Algo para dizem enquanto os atletas se registram?',
    registrationContentSpecial:
      'Caso queira que qualquer conteúdo especial apareça no topo de seu formulário de registro, como a política de reembolso ou outras coisas importantes para os atletas saberem antes de comprar o ticket, adicione aqui. Caso contrário, deixe em branco.',
    registrationConfigured: 'Registro para <span class="comp-name">{compName}</span> foi configurado com sucesso!',
    accountHeader: 'Sua conta',
    accountSettings: 'Configurações da conta',
    languagePreference: 'Preferência de Idioma',
    accountSubscription: 'Subscrição',
    accountEmailAddress: 'Endereço de email',
    accountPassword: 'Senha',
    accountConfirmPassword: 'Confirmar senha',
    profileSettings: 'Configurações de perfil',
    profileUsername: 'Nome de usuário',
    profileUsernamePlaceholder: 'Digite um nome de usuário',
    profileUsernameCanBeSetOnce:
      'Seu nome de usuário pode ser definido apenas uma vez e não pode ser alterado.',
    profileSetUsername:
      'Defina seu nome de usuário para editar os detalhes do seu perfil.',
    profileGender: 'Gênero',
    profileName: 'Nome',
    profileFirstNamePlaceholder: 'Primeiro nome',
    profileLastNamePlaceholder: 'Último nome',
    profileDisplayName: 'Mostrar nome',
    profileDisplayNamePlaceholder:
      'Nome de exibição preferido nas tabelas de classificação',
    profileBio: 'Sobre mim',
    profileBioPlaceholder: `Este campo é onde você pode enviar detalhes adicionais sobre si mesmo como atleta! Muitos de nossos usuários incluem tópicos como:

      - Rotina de exercícios
      - Dieta
      - Destaques da competição
      - Hobbies

E mais! Você sempre pode voltar e editar sua biografia a qualquer momento, se não tiver certeza do que dizer no momento.`,
    profileAssociationsHeader: 'Associações',
    profileCountry: 'País',
    profileAffiliate: 'Afiliado',
    profileAffiliatePlaceholder: 'Onde você treina',
    profileSocialHeader: 'Perfis Sociais',
    profileTwitterHandlePlaceholder: 'Seu identificador do Twitter',
    profileFacebookUsernamePlaceholder: 'Seu nome de usuário do Facebook',
    profileInstagramHandlePlaceholder: 'O seu identificador do Instagram',
    profileMustSetUsernameToSave:
      'Você deve definir seu nome de usuário para salvar seu perfil.',
    profilePublic: 'O perfil é público.',
    profilePrivate: 'O perfil é privado.',
    profilePublicLink: 'Link do perfil',
    profilePublicLinkDescr: 'Um link para compartilhar seu perfil público.',
    athleteAthleteBio: 'Biografia do atleta',
    athleteUsernameNotFound: 'Parece que o perfil não existe.',
    athleteNoBio:
      'Este atleta ainda não forneceu nenhuma informação biográfica.',
    unspecified: 'Não especificado',
    onlineScoring: 'Pontuação online',
    content: 'Conteúdo',
    timeAndPlace: 'Tempo e Lugar',
    help: 'Ajuda',
    coupons: 'Cupons',
    customWaiver: 'Desistência Personalizada',
    customFields: 'Campos Personalizados',
    scoringPolicies: 'Políticas de Pontuação',
    marketing: 'Marketing',
    guidedSetup: 'Configuração guiada',
    retail: 'Varejo',
    fees: 'Taxas',
    dates: 'Datas',
    deposits: 'Depósitos',
    advanced: 'Avançado',
    registrants: 'Inscritos',
    scoreEntry: 'Entrada de Pontos',
    management: 'Gerenciamento',
    support: 'Suporte',
    dataEntryLinks: 'Links de entrada de dados',
    leaderboardSettings: 'Leaderboard Settings',
    noContent: 'Sem conteúdo',
    editContent: 'Editar Conteúdo',
    registrationContent: 'Conteúdo de Registro',
    registrationLead:
      'Caso você queira que qualquer instrução especial apareça no topo do seu formulário de registro como a política de reembolso ou outras coisas importantes para informar os atletas antes da compra dos tickets, adicione aqui. Caso contrário, você pode deixar em branco.',
    connectToAStripeAccount: 'Conecte a uma conta no Stripe',
    connectToNewStripeAccount: 'Conecte a uma nova conta Stripe',
    stripeLead:
      'Somos parceiros da Stripe, o melhor processador de pagamento da indústria, para que você tenha sempre completo controle de seus fundos de registros.',
    stripeNotConnected: 'Você ainda não conectou com uma conta Stripe',
    letsDoThatNow: 'Vamos fazer isso agora',
    yourStripeAccounts: 'Suas contas Stripes',
    yourStripeAccountsDescr:
      'Quais destas contas Stripe deveriam receber os depositos para esta competição?',
    depositsNeedHelp: 'Precisa de ajuda com o depósito? Contate-nos em',
    youWillReceive: 'Você receberá pagamentos através da sua conta Stripe <strong>{acctName}</strong> .',
    stripeOptOut:
      'Já que você optou por não usar o Stripe, nós vamos coletar suas taxas de registro para você. Os fundos serão liberados 45 dias depois que sua competição acabar e depois de cobrar uma taxa de processamento de $150.',
    registrantDivisionTitle: '{divTitle} Inscritos',
    registrantsExport: 'Preparar exportação',
    registrantsExportPrep: 'Preparando...',
    registrantsExportView: 'Visualizar exportação',
    registrantsLeaderboardName: 'Nome do placar',
    registrantsTeamMembers: 'Membros da equipe',
    registrantsAthleteName: 'Nome do atleta',
    registrantsDate: 'Registrado em',
    registrantsCharges: 'Cobranças',
    registrantsChangeDivision: 'Mudar divisão',
    registrantsAddDivision: 'Register for Additional Division',
    addCoupon: 'Adicionar Cupons',
    loadingCoupons: 'Carregando os cupons...',
    registrationWaiverContent: 'Conteúdo de desistência do registro',
    registrationWaiverContentLead:
      'Esta desistência padrão deve funcionar bem, mas se você tiver a sua própria e gostaria que os os atletas inscritos concordassem, então você só precisa substituí-la.',
    addField: 'Adicionar campo',
    customRegistrationFields: 'Campos de registro personalizados',
    loadingRegistrationFields: 'Carregando campos de registro',
    label: 'Rótulo',
    labelDescr: 'O rótulo para o seu campo.',
    helpText:
      'O texto de ajuda para o seu campo. Este texto é o \'texto de ajuda\'',
    helpTextLabel: 'Texto de ajuda',
    requiredField: 'Solicite que este campo seja preenchido durante o registro',
    requiredFieldLabel: 'Requerido',
    team: 'Team',
    teamField: 'Team Question',
    teamFieldLabel: 'This question will only be asked once per registration',
    fieldChoices: 'As escolhas para este campo separados por vírgula',
    fieldChoicesLabel: 'Escolhas do campo',
    fieldPreview: 'Pre-visualização do campo',
    couponCode: 'Código do Cupom',
    percentageOff: 'Porcentagem de Desconto',
    amountOff: 'Valor de Desconto',
    numberAvailable: 'Número disponível',
    expiration: 'Expiração',
    add: 'Adicionar',
    editCoupon: 'Editar Cupom',
    scoringLink: 'Link de pontuação',
    shareThisLink:
      'Compartilhe este link de segurança e privacidade com a equipe para ajudar nas pontuações',
    shareThisTicketLink:
      'Compartilhe este link privado e seguro com a equipe para obter ajuda no gerenciamento de tickets',
    scoring: 'Pontuação',
    previewLeaderboard: 'Preview da Tabela de Pontuação',
    publishedLeaderboard: 'Publicar Tabela de Pontuação',
    refreshing: 'Atualizando',
    enterScoresStatement:
      'Insira algumas pontuações na aba de pontuação para gerar uma prévia nesta aba.',
    publishedLeaderboardLink: 'Este é um placar publicado disponível em',
    noLeaderboardPublishedStatement:
      'Você não publicou um placar para esta divisão ainda. Insira alguns pontos na aba de pontuação e então publique um placar dentro de uma Prévisualização da aba de pontuação',
    youMadeChangesStatement:
      'Você fez mudanças no placar. Previsualize o placar e publique.',
    noScoresDivision:
      'Não há pontuação inserida para esta divisão. Adicione as novas pontuações abaixo.',
    name: 'Nome',
    addNew: 'Adicionar nome',
    score: 'Pontos',
    tieBreaker: 'Desempate',
    review: 'Revisar',
    yourScores: 'Seus pontos',
    scoresFor: 'Pontos para',
    mustAuth: 'Você deve autorizar para gravar sua pontuação',
    instructions: 'Instruções',
    scaled: 'Dimensionado',
    video: 'Video',
    withdraw: 'Desistir',
    scoringClosed: 'Pontuação fechada',
    withdrawing: 'Desistindo',
    scoringIsOpenFrom: 'A pontuação está aberta de',
    addScore: 'Adicionar pontuação',
    scoringIsClosed: 'A pontuação está fechada',
    window: 'janela',
    scoreDescr: 'Qual foi sua pontuação?',
    timeScoreDescr: 'Digite o tempo que levou para concluir todo o treino.',
    repScoreDescr:
      'Digite o número de representantes que você conseguiu concluir dentro do limite de tempo.',
    tieBreakDescr: 'Qual foi seu desempate?',
    certification: 'Certificação',
    rx: 'Rx',
    rxCertifyStatement:
      'Eu completei o treino de acordo com os padrões escritos para essa divisão.',

    scaledCertifyStatement:
      'I understand my scores will rank below athletes who followed the standards in this division.',
    selectRxStatement:
      'Selectione Rx se você completou o treino pelos padrões fornecidos <strong>para sua divisão</strong>. No contrário, selecione Dimensionado para indicar que você dimensionou o treino além dos padrões <strong>para sua divisão</strong>.',
    certificationHelp:
      'Marque esta caixa se você não modificou os padrões para sua divisão (pesos mais leves, movimentos modificados, etc.)',
    certificationDescription:
      'Deixar esta caixa vazia significa que você modificou o exercício de alguma forma. Sua pontuação aparecerá na parte inferior da tabela de classificação.',
    videoLink: 'Link do video',
    videoLinkDescr:
      'O link para o YouTube ou outro site de videos do seu treino',
    imageLink: 'Imagem',
    imageLinkDescr:
      'Faça upload de uma imagem a ser usada para verificação de pontuação',
    judge: 'Juíza',
    judgeDesc: 'O nome da pessoa que observou seu treino',
    comments: 'Comentários',
    expired: 'Expirado',
    expiresOn: 'Expirado em ',
    extend: 'Extender',
    expire: 'Expirar',
    activate: 'Activate',
    deactivate: 'Deactivate',
    active: 'Active',
    inactive: 'Inactive',
    externalScoreThanks: 'Agradecemos pelos pontos!',
    hangTight: 'Fique firme',
    exitWithoutSavingSure: 'Tem certeza de que quer sair sem salvar?',
    continueEditing: 'Continuar editando',
    exitWithoutSaving: 'Sair sem salvar',
    finalReviewStatement:
      'Sua competição está sob uma revisão final para ir online!',
    dashboardSummary: 'Um resumo de como sua competição está indo.',
    summary: 'Resumo',
    revenue: 'Receita',
    views: 'Visualizações',
    registrations: 'Registros',
    outOf: 'fora de',
    divisionCapacity: 'Capacidade da Divisão',
    by: 'por',
    cumulativeTotalRevenue: 'Receita total acumulada',
    performance: 'Desempenho',
    regAndTrafficStatement:
      'Registros e tráfego da página inicial da sua competição.',
    scoreSubmissionHeader: 'Envio de pontuação do Atleta',
    athleteAlreadyExists: 'Atleta já inserido',
    workoutSubmitScore: 'Enviar pontuação',
    only: 'só',
    spots: 'local | locais',
    remaining: 'restantes',
    stripeDeclined: 'Seu cartão foi recusado.',
    stripeInsufficient: 'Seu cartão não tem fundos suficientes.',
    twitterMessage: '{compName} parece ótimo. Veja:\n\n{href}',
    shareEmailSubject: 'Veja {compName}',
    shareEmailMessage: '{compName} parece ótimo. Veja:\n\n{href}',
    deleteCouponMessage: 'Tem certeza de que quer apagar o cupom <strong>{code}</strong> ?',
    unsupportedBrowHead: 'Navegador não suportado',
    unsupportedBrowButton: 'OK',
    unsupportedBrowDescr: 'Parece que você está usando um navegador antigo, um navegador não suportado. Você pode ter dificuldades usando este aplicativo. Atualize para garantir a melhor experiência possível.',
    networkErrorHead: 'Erro de Rede',
    networkErrorButton: 'Tente Novamente ',
    networkErrorDescr: 'Sua conexão de rede foi perdida.',
    clipboardCopy: '¡Copiado!',
    waiverClose: 'Fechar Waiver',
    waiverShow: 'Mostrar Waiver',
    couponDiscount: '{discount}% de desconto',
    failedRegistration: 'Houve um problema',
    competitionFullHeader: 'Competição está Cheia',
    divisionsFullDescr:
      'Todas as divisões estão esgotadas. Por favor entre em contato com o organizador para perguntar sobre uma lista de espera.',
    invitationInviteesCount: 'Invitee(s)',
    registrationRequiredFieldsWarning:
      'Please fill out all the required fields.',

    subtotal: 'Subtotal',
    regCardEndingMessage:
      'Você está performando essa transação em um cartão finalizado em',
    merchandise: 'Produto',
    orderMerchItem: 'Item',
    orderMerchPrice: 'Preço',
    orderMerchQty: 'Qtd',
    orderMerchSoldOut: 'Esgotado',
    orderMerchCouponDis: 'Cupom de Desconto',
    orderMerchSubtotalDis: 'Subtotal Descontado',
    orderMerchNow: 'Pedir Agora',
    merchHeader: 'Itens de Varejo',
    merchAddItem: 'Adicionar um item de venda',
    merchQty: 'Quantidade inicial',
    merchQtyDescr: 'Quantos destes você tem disponível para venda?',
    merchExchangeable: 'Permutável',
    merchExchangeableDescr:
      'Este item é algo que pode ser trocado por um item diferente?',
    merchItemName: 'Nome do item',
    merchItemNameDescr: 'O nome do item para venda',
    addItemDescrHeader: 'Descrição do Item',
    addItemDescrDescr: 'Uma pequena descrição do seu item',
    merchImageUpload: 'Adicione uma imagem para o item',
    merchImageHelp:
      'Dimensão sugerida: {width}x{height}. (Você pode dar zoom/cortar depois do upload)',
    merchLoading: 'Carregando Items à Venda...',
    orderMerchButton: 'Pedir Produto',
    editDetailsButton: 'Editar Detalhes',
    releaseTime: 'Tempo de Liberação',
    releaseTimeDescription:
      'Selecione o tempo que você gostaria que os detalhes do seu treino fosse revelados aos atletas. Treinos antes do ‘Tempo de Lançamento’ terão um placeholder de ‘Treino TBA’. ',
    invalidVideo: 'Vídeo Inválido',
    athleteComment: 'Comentário do Atleta',
    exportAsCSV: 'Exportar como CSV',
    scoringImportAthletes: 'Importar',
    scoringImportAthletesDescr:
      'Cole os nomes dos seus atletas para adicioná-los na tabela de pontuação.',
    importingAthletes: 'Importando...',
    bibNumbers: 'Número Bib',
    enterBibNumber: 'Coloque o número Bib ',
    toggleBibs: 'Alternar Bibs',
    noWorkoutFound: 'Nenhum Treino Encontrado',
    noWorkoutFoundDescr: 'Esse treino não existe.',
    noDivisionFound: 'Nenhuma Divisão Encontrada',
    noDivisionFoundDescr: 'Essa divisão não existe.',
    merchReceiptQty: 'Quantidade',
    merchPurchasedItems: 'Itens Comprados',
    registrationClosedBody: 'Registrar Fechado',
    registrationClosedBodyDescr: 'O registro está encerrado.',
    totalRepsInWorkout: 'Contagem total de repetição',
    totalRepsInWorkoutNA: 'Contagem total de repetição - N/D',
    totalRepsInWorkoutDescr:
      'If this workout has a time cap and involves counting the number of reps completed, enter the total rep count for the workout. Leave field blank if not applicable.',
    minimumWorkNotMet: 'Trabalho mínimo não cumprido',
    minimumWorkRequired: 'Trabalho Mínimo Requerido',
    minimumWorkRequiredDescr: 'Se a pontuação de um atleta não atingir ou exceder este valor para o treino, ele será movido para a parte inferior da tabela de classificação geral.',
    timeCap: 'Limite de tempo',
    timeCapDescr:
      'Se este treino tiver um limite de tempo, insira-o usando horas, minutos e segundos.',

    competitionCard: {
      duplicateAlert: 'Tem certeza que quer duplicar esta competição?'
    },
    divisionTeamReqMessage: '{teamSize}-membros da equipe requeridos',
    throwdownsWaiver: `<h4>Hipótese de Isenção de Responsabilidade de Participação de Acordo e Risco </h4>
    <p>Com relação à participação neste programa, eventos e atividades relacionados, eu reconheço e concord que:</p>
                <ul>
                <li>O risco de lesão das atividades envolvidas neste programa são significantes, inclusive a possibilidade de haver paralisia ou morte.</li>
                <li>Estou ciente dos riscos e os aceito de livre e espontânea vontade, tanto os conhecidos quanto os desconhecidos, mesmo se eles vêm de negligência por parte dos liberados ou outros, e aceito a integral responsabilidade pela minha participação.</li>
                <li>Eu aceito livremente cumprir com os termos e condições para a participação. Se eu ver qualquer perigo incomum e significante durante a minha presença, ou participação, eu cessarei de participar e alertar o oficial mais próximo imediatamente.li>
                <li>Eu, por mim mesmo, e em nome dos meus herdeiros, executores, administradores, representantes pessoais, sucessores e outorgados, renuncio todos e quaisquer direitos, reivindicações e ações que tenho ou possa ter contra os organizadores ou qualquer pessoa associada à entidade, seu Patrocinador Principal e seus afiliados, agentes, funcionários, oficiais, diretores, sucessores e outorgados, a empresa de gerenciamento de eventos, a Cidade, os Distritos de Parques, e todos e quaisquer patrocinadores, seus representantes e sucessores, que possam surgir como resultado da minha participação no evento e em quaisquer atividades antes e após o evento.</li>
                <li>Eu certifico e dou fé que estou sou fisicamente capaz e que treinei  suficientemente para completar este programa, evento relacionado e/ou atividades relacionadas, e um médico licenciado verificou a minha condição física. </li>
                <li>Ademais, eu dou total permissão para todos as partes mencionadas acima usarem quaisquer fotos, filmes, gravações ou qualquer outro registro desse evento para qualquer motivo legítimo, inclusive para propagandas.</li>
                <li>Eu certifico que tenho +18 anos de idade ou que tenho autorização dos pais para participar de exercícios físicos árduos.</li>
                </ul>`,

    setupProgramming: '@:Configurar @:Programação',
    setupRegistration: '@:Configurar @:Cadastro',
    setupPayments: '@:Configurar @:Pagamentos',
    publishRequested: '@:Publicar @:Pedido',
    requestPublish: '@:Publicar @:Publicar',
    viewRegistration: '@:Visualizar @:Cadastro',
    registerNow: '@:Registrar @:Agora',
    buyTicketsHeader: 'Buy Tickets Today',
    registrationClosed: '@:Registrar @:Fechado',
    noWorkoutForThisDivision: '@:Nenhum @:Treino para essa @:Divisão',
    noDivisionsForThisWorkout: '@:Nenhuma @:Divisão para este @:Treino',
    yesDelete: '@:Sim, @:Apagar',

    heatScheduling: 'Agendamento',
    heatsSubMenu: 'Gerenciar Heats',
    heatsLocations: 'Localizações',
    heatsWorkoutLocations: 'Localização dos Treinos',
    heatsSchedules: 'Agendas',
    heatsSegments: 'Segmentos',
    athleteAssignmentsLabel: 'Athletes',
    heatManageAssignments: 'Heat and Lane Assignments',
    heatsManageTimes: 'Gerenciar Heats',
    schedule: 'Agenda',
    heatsJudges: 'Juízes',
    loadingLocations: 'Carregando Localizações...',
    addLocation: 'Adicionar Localização',
    heatsWorkoutParams: 'Parâmetros do Treino Heat ',
    workoutDurationDesc:
      'A quantidade de tempo (minutos) alocado para um atleta completar esse treino',
    workoutDurationLabel: 'Duração',
    configStartEnd: 'Tempo',
    actualStartEnd: 'Tempo',
    workoutTransitionTimeDesc:
      ' A quantidade de tempo (minutos) alocado para a transição entre atletas',
    workoutTransitionTimeLabel: 'Tempo de Transição',
    workoutNumberOfLanesDesc: 'O número de faixas disponíveis para esse treino',
    workoutNumberOfLanesLabel: 'Número de Faixas',
    workoutTimeCapDescr: 'O limite de tempo para este treino é de {timeCap}',
    workoutTimeCapAllRepsCompleted:
      '<strong> Todos os {totalRepsInWorkout} representantes </strong> foram concluídos dentro do limite de tempo.',
    workoutTimeCapFewerRepsCompleted:
      '<strong> Menos de {totalRepsInWorkout} representantes </strong> foram concluídos dentro do limite de tempo.',
    heatsLaneEmpty: '{heat} {lane} Vazia',
    heatsJudgeLaneEmpty: 'Faixa está vazia',
    heatsLane: 'Faixa {athleteIndex}',
    heatsPending: 'Esperando Atleta',
    calculating: 'Calculando...',
    publishing: 'Publicando...',
    heatsStartEnd: 'Tempos de Começo e Fim',
    heatsStartEndDescr:
      'O tempo de começo e fim desejados para a agenda desse dia',
    heatsTransTime: 'Tempo de Transição',
    heatsTransTimeDescr:
      'O tempo de transição entre a conclusão de um treino/divisão e o começo do próximo. Aumentar em 5 minutos.',
    lane: 'Faixa',
    backToTop: 'De volta ao topo',
    back: 'Voltar',
    next: 'Próximo',
    empty: 'Vazio',
    printCancel: 'Cancelar Print',
    heatsNoPlans: 'Nada planejado',
    heatsStageWorkouts: 'Treinos para essa Localização',
    heatsStageWorkoutsDescr:
      'Selecione e ordene os treinos que vão acontecer nessa localização para cada dia de sua competição.',
    stageNameDescr:
      'O nome da localização que você está criando. Exemplos: Barra de Pull-up, Plataforma de Haltere, Lago, Pista, etc.',
    locationName: 'Nome da Localização',
    schedulingConfig:
      'Vamos configurar as configurações iniciais para sua agenda heat!',
    schedulingSecondary:
      'Passaremos por três seções durante esse processo de configuração: criar os diferentes segmentos de tempo de sua programação, estabelecer os locais dos seus treinos e definir parâmetros importantes de treinamento, como durações de exercícios e número de faixas..',
    schedulingSegments:
      ' Nesta etapa, você definirá as horas de início e fim de cada segmento da sua competição. Nós fornecemos alguns segmentos padrão para você baseados no número de dias em que sua competição está sendo executada.',
    schedulingStages:
      'Nesta etapa, você criará seus locais de treinamento e atribuirá exercícios a eles. Pense nos locais em que as diferentes estações ou locais de treinamento serão concluídos. Fornecemos locais de amostra para você.',
    schedulingWorkouts:
      'Nesta etapa, você ajustará os vários parâmetros de treinamento que atribuiu aos seus locais. Esses parâmetros incluem duração, tempo de transição e número de faixas. Nós fornecemos alguns padrões para você começar.',
    schedulingConfigured:
      'Os passos iniciais para a criação da sua agenda heat foram configuradas com sucesso!',
    schedulingFinal:
      'Agora, você vai ir para a aba de Agendamento, onde você pode ver como seu(s) crognograma(s) serão \'divididos\' nas diferentes seções.',
    schedulePageTitle: 'Agenda',
    scheduleYours: 'Sua Agenda',
    loginSchedule: 'Para ver sua Agenda,',
    missingDataWarning:
      'Sua competição não está configurada adequadamente para o Organizador conseguir executar. Se você quiser desenhar uma agenda, você vai precisar resolver os seguintes requerimentos e voltar aqui depois:',
    noDivisionsWarning: 'Nenhuma divisão foi definida para essa competição.',
    noWorkoutsWarning: 'Nenhum treino foi definido para essa competição.',
    noStagesWarning:
      'Nenhuma localização foi definida para a agenda dessa competição.',
    schedulingInfo:
      'Nessa aba, você pode ver e gerenciar os vários segmentos criados. Clique no ícone suspenso para obter uma visão detalhada do seu segmento, onde você pode definir a ordem de divisão e estabelecer tempos de transição globais',
    schedulingPanelInfo:
      'Abaixo estão diferentes etapas da sua competição. Divisões podem ser reordenadas dentro de cada etapa.',
    schedulePageInfo:
      'Nenhuma agenda foi publicada ainda para essa competição. Para mais informações, entre em contato com o organizador do evento usando o e-mail abaixo.',
    confirmPublish: 'Confirmar',
    addSegment: 'Adicionar Segmento',
    segmentTitle: 'Título do Segmento',
    segmentTitleDesrc: 'Qual o nome desse Segmento?',
    loadingSegments: 'Carregando Segmentos...',
    heatsDraft: 'Rascunho',
    minute: 'minuto',
    minutes: 'minutos',
    second: 'segundo',
    seconds: 'segundos',
    seedingInfo:
      'Nesta aba, você pode modificar o seed do atleta. A seed aleatória de seus atletas foi aplicada automaticamente. Clique no ícone suspenso para substituir essa propagação em um atleta por caso de atleta. Números mais baixos indicam maior classificação (1 > 4).',
    manageHeatsInfo:
      ' Nesta aba, você pode ver e gerenciar os heats de cada programação que você criou. Clique no ícone suspenso para visualizar e trocar as atribuições de faixa com base no heat.',
    timeBlockLabel: 'Time Box Only',
    timeBlockDesc:
      'This segment will not have any heats but rather just be a box of time on your schedule.',
    timeBlockCheckBoxText: 'Yes, flag as a time box segment.',
    expand: 'Expandir',
    heatsNoJudges: 'Nenhum juiz foi nomeado aind ',
    configuration: 'Configuração',
    defaultErrorMessageSavingJudgeName: 'Erro ao Salvar. Tente novamente!',
    heatsNoHeatsSegment: 'Nada agendado para esse segmento ainda',
    deleteConfirm: 'Deletar',
    schedulePublishWarning:
      'Vai tornar a agenda pública e permitir aos atletas de ver seus heats pessoais.',
    scheduleUnpublishWarning:
      'Cancelar a publicação vai remover a agenda da página inicial pública e esconder os heats pessoais dos atletas. Tem certeza que quer continuar?',
    heatsLastSegmentWarning:
      'Você deve ter pelo menos um segmento e esse vai ser o único que você terá.',
    heatsLastLocationWarning:
      'Você deve ter pelo menos um local de treino e esse vai ser o único que você terá.',
    heatsDeletePublishedLocationWarning:
      'Um ou mais dos seus segmentos usando essa localização estão em uma agenda publicada.',
    heatsSchedulesNoWorkout: 'Nenhum treino atribuído.',
    heatsSchedulesAssignWorkout: 'Atribuir algum.',
    heatsSchedulesInvalidWarning:
      'Parâmetros Inválidos. Não foi possível computar agenda.',
    heatsSwappingNotification:
      'Selecione outro atleta dentro desse treino para trocar faixas/heats.',
    heatsSeedsNoAthletes: 'Nenhum atleta registrado para essa divisão',
    heatsFetchRegistrations: 'Buscando registros...',
    heatsHeatsJudgesInvalidSchedule:
      'A agenda para esse segmento é inválida. Por favor a corrija para continuar.',
    heatsSchedulesPublishedWarning:
      'Você não pode fazer qualquer mudança aqui porque a agenda desse segmento já foi publicada.',
    heatsCreated: 'Criado',
    heatsSchdulesTimeOverSegmentWarning: 'Sua agenda já passou <strong>{timeOver} minutos</strong> do final do segmento. Você pode ajustar o tempo de transição entre divisões, parâmetros de treino, e/ou tempos finais dos segmentos para resolver esse problema.',
    heatsPreviewInstructions: 'Esse é um preview do que será publicado na sua página inicial. Cada <em>Segmento</em> é publicado individualmente, te permitindo começar a agenda quando estiver pronto.',
    heatsPreviewRegOpenWarning:
      'Não é possível publicar até que a inscrição encerre',
    unpublish: 'Cancelar Publicação',
    confirmUnpublish: ' Cancelar Publicação',
    areYouSure: 'Você tem certeza?',
    areYouSurePublish: 'Você tem certeza de que está pronto para publicar?',
    areYouSureUnpublish:
      'Você tem certeza de que está pronto para cancelar a publicação?',
    unpublishWarningIntro:
      'Depois de cancelar a publicação, algumas ações podem fazer com que sua agenda seja completamente regenerada:',
    unpublishWarningDivisions: 'Adicionando ou deletando divisões ',
    unpublishWarningWorkouts: ' Adicionando ou deletando treinos',
    unpublishWarningAdvancedWorkouts:
      'Excluindo ou incluindo treinos nas divisões como parte do gerenciamento de política avançada de pontuação',
    unpublishWarningWorkoutHeats: 'Mudando os parâmetros do treino heat',
    unpublishWarningWorkoutLocations:
      'Adicionando ou deletando localizações de treino',
    unpublishWarningWorkoutLocationsConfig:
      'Mudando configurações de locais de treino',
    unpublishWarningSeeding: 'Mudando seeds dos atletas',
    unpublishWarningBody:
      'Fazer qualquer um dos itens acima após cancelar a publicação resultará na regeneração da sua programação. Isso significa que qualquer juiz que você tenha colocado será perdido e o horário / locais que seus atletas já tenham visto provavelmente mudarão.',
    pleaseConfirm: 'Por favor confirme',
    unpublishWarningTypePublish:
      'Digite \'unpublish\' para confirmar de que você realmente quer fazer isso.',
    heatsPreviewInvalidWarning:
      'Agenda não é válida. Corrija antes de publicar.',
    heatInvalidStartHere: 'Comece aqui.',
    publishedScheduleWarningHeader: 'Você tem uma agenda publicada',
    /// Translators: The next three entries are together, and need to be translated as one sentence.
    publishedScheduleWarningBody1: 'Você deve',
    publishedScheduleWarningBody2: 'cancelar essa publicação',
    publishedScheduleWarningBody3: 'para conseguir fazer mudanças.',
    /// End grouping...

    /// The below translation is led with a competition name, like "Comp1 has been submitted for review!"
    launchModalHeader: 'foi submetida para o review!',
    launchModalLead1:
      'Incrível! Você criou sua competição com sucesso e nos enviou para que possamos fazer o review.',
    launchModalLead2: 'Nossa equipe vai:',
    launchModalList1: 'Rever os detalhes da sua competição',
    launchModalList2:
      'Entrar em contato sobre nossas diversas formas de pagamento',
    launchModalList3: 'Confirmar a data que você quer publicar sua competição',
    launchModalLead3:
      'Estamos orgulhosos por fecharmos essa parceria com você para lançarmos uma competição incrível!',
    launchModalButton: 'Certo! Vamos começar!',

    intentModalHeader: `Bem Vindo à ${APP_NAME}!`,
    intentModalIntro:
      'Estamos empolgados para começar! Nos ajude a personalizar sua experiência contando um pouco sobre você.',
    intentModalOptionSelect: 'Eu quero:',
    intentModalParticipant: 'Eu sou um Participante',
    intentModalParticipantDescr1: 'Registrar para uma competição',
    intentModalParticipantDescr2: 'Ver tabela de pontuação',
    intentModalParticipantDescr3: 'Descobrir novas competições',
    intentModalParticipantButton: 'Começar Aqui',
    intentModalOrganizer: 'Eu sou um Organizador',
    intentModalOrganizerDescr1: 'Criar e gerenciar uma competição',
    intentModalOrganizerDescr2: 'Adicionar/Rever Pontuações',
    intentModalOrganizerDescr3: 'Publicar Tabelas de Pontuação',
    intentModalOrganizerButton: 'Começar Aqui',
    intentModalSpectator: 'I am a Spectator',
    intentModalSpectatorDescr1: 'Buy tickets for a competition',
    intentModalSpectatorDescr2: 'View leaderboards',
    intentModalSpectatorDescr3: 'Discover new competitions',
    intentModalSpectatorButton: 'Start Here',

    dashboardOrganizerNoComps:
      'Você ainda não criou nenhuma competição. <strong>Adicione uma Competição</strong> para começar!',
    dashboardParticipantNoComps:
      'Você atualmente não está registrado para nenhuma competição. <strong>Encontre uma Competição</strong> para começar!',
    dashboardSpectatorNoComps:
      'You currently don\'t have tickets to any competitions. <strong>Find a Competition</strong> to get started!',
    scoresubModalClose: 'Fechar',
    athleteToggle: 'Participante',
    organizerToggle: 'Organizador',
    spectatorToggle: 'Spectator',
    findCompButton: 'Encontrar uma Competição',
    findCompHeader: 'Encontrar uma Competição ',
    findCompSearchHeader: 'Procurar uma Competição',
    findCompSearchDescr:
      'Procure por uma competição por nome para encontrar uma na qual você esteja interessado para se registrar',
    findCompSearchResults: 'Resultados da Pesquisa',
    findCompResultLandingPage: 'Página de Entrada',
    findCompFetchLocation: 'Buscando Localização...',
    findCompUseLocation: 'Usar Minha Localização',
    findCompFetchSuggestions: 'Buscando Sugestões...',
    findCompRecentlyViewed: 'Vistas Recentemente',
    findCompNoSuggestions: 'Nenhuma sugestão encontrada.',
    findCompFetchSearchResults: 'Buscando Resultados de Pesquisas...',
    findCompNoSearchResults:
      'Não encontramos nenhuma competição que esteja de acordo com seus termos de busca.',
    findCompSuggestions: 'Sugestões',

    acceptTerms: 'I accept the',
    latestTerms: 'latest terms of service',
    submitConsent: 'Accept',
    tosUpdated: 'Our Terms of Service has been updated!',

    launchPublishModal: 'Launch Your Competition!',
    readyToLaunch: 'Lets do this!',
    areYouReadyToLaunch:
      '<p class=\'lead\'>Launch your Competition</p><p>It\'s free for you to launch a competition. Participants pay processing fees when they register per the terms of service.</p>',

    bibNumber: 'Bib #',
    registrationAccess: 'Registration Access',
    registrationAccessHeader: 'Registration Access',
    registrationAccessCheckboxMessage:
      'Allow athletes to update their registrations',
    registrationAccessDescr:
      'Por padrão, os atletas podem atualizar seus detalhes de registro a qualquer momento. Isso inclui alterar quaisquer respostas de campo personalizadas, bem como mudar sua divisão. Desmarcar esta opção impedirá que os atletas possam atualizar suas informações de registro ou alterar sua divisão após o registro.',
    regDetailDescription: 'Description',
    regDetailQuantity: 'Quantity',
    regDetailRegistration: 'Registration',
    regDetailPurchases: 'Purchases',
    regDetailAdd: 'Add',
    regDetailDivision: 'Division',
    regDetailBib: 'Bib #',
    regDetailLeaderboardName: 'Leaderboard Name',
    regDetailTeamMember: 'Team Member #',
    regDetailEmail: 'Email',
    invitationsMenuLabel: 'Invitations',
    invitationPageHeader: 'Invitations',
    createInvitationLabel: 'Create',
    manageInvitationsLabel: 'Manage',
    createInvitationPageHeader: 'Create an Invitation',
    createInvitationPageIntro:
      'Compose your message, add and rank your invitees, and save as you go.  Hit Publish when you are ready to start sending your invites.',
    invitationFormLabelMustMatch: 'Email Must Match',
    invitationFormHelpMustMatch: 'The email of the accepting user must match the email that was invited.',
    invitationFormLabelLabel: 'Invitation Label',
    invitationFormLabelDescription:
      'The name of your campaign. This is a reference for your use only.',
    invitationFormLabelDivision: 'Division',
    invitationFormHelpDivision:
      'The division to invite someone to.  Setting it blank allows the invitee to pick their division.',
    invitationFormHelpDivision2:
      'Invites with unassigned divisions may not have a registration slot reserved for them due to sellouts.',
    invitationFormLabelExpireDays: 'Expire Days',
    invitationFormHelpExpireDays:
      'The number of days from when the email is sent to when the invitation expires. Setting it blank means invitations never expire and all emails will be sent an invitation once published.',
    invitationCampaignsHeader: 'Invitation Campaigns',
    invitationCampaignsLead: 'Create and manage your invitation campaigns.',
    invitationCampaignsHelp:
      'Click on the invitation “Label” to get a detailed view on your campaign status.',
    invitationDetailHelpText:
      'Your invitation has been scheduled to send and will start going out shortly.',
    invitationStopWarning:
      'Pressing this button will stop this campaign from sending any more invites and end the campaign permanently.',
    invitationStopHelp:
      'Stopping this invitational will prevent any more invites from being sent, but will not revoke any invites that have already been delivered. Are you sure you want to proceed?',
    invitationPublishConfirmHelp:
      'Publishing your invitation campaign will make it live and start the process of sending out invites. Once you publish, you will not be able to edit your email, add more invites, or rearrange invite order. Are you sure you are ready to publish?',
    publishConfirm: 'Yes, Publish',
    inviteOnlyCompRegistrationHelpText:
      'You must receive an invite to register for this competition. Please reach out to your organizer for more information.',

    saveDraft: 'Save Draft',
    createInvitationDraft: 'Create Invitation Draft',
    compose: 'Compose',
    invite: 'Invite',
    saveInviteList: 'Save Invitees',
    inviteMessagePreviewLoading: 'Rendering Preview...',
    invitationsEmailImportLabel: 'Import Email Addresses',
    invitationsEmailImportHelpText:
      'Copy and paste email addresses of those you wish to invite (either one per line or comma/space delimited)',
    manageInvites: 'Manage Invites',
    addInvites: 'Add Invites',
    inviteDetailEmail: 'Email',
    inviteDetailSent: 'Sent',
    inviteDetailExpires: 'Expires',
    inviteDetailStatus: 'Status',
    inviteStopCampaign: 'Stop Campaign',
    inviteStop: 'Stop',
    inviteConfirmStop: 'Yes, Stop',
    inviteDetailDescr:
      'Invites will be sent based on priority, starting from the top of the list.  As invitations are accepted or expire, more will be sent. Once all invites have been sent or have expired, the campaign will end.',
    inviteDetailExpireDays: 'Invitations will expire <strong>{invitation_expire} day(s)</strong> from when they are sent.',
    inviteManageLabel: 'Label',
    inviteManageStatus: 'Status',
    inviteManageTotalInvites: 'Total Invites',
    inviteManageSent: 'Sent',
    inviteManageAccepted: 'Accepted',
    invitationFormLabelMessageHeader: 'Brief message (optional)',
    invitationFormLabelMessageDescr:
      'We will include this message in the generated invitation email.',
    inviteStatusExpired: 'Expired',
    inviteStatusAccepted: 'Accepted',
    inviteStatusDeclined: 'Declined',
    inviteStatusBadEmail: 'Bad Email Address',
    inviteStatusPending: 'Pending',
    inviteDefaultMessage: 'We are happy to invite you to register for {message}!',
    invitationManageSecHeader:
      'Drag and drop to re-order invitees. Invites will be sent based on priority from top to bottom.',
    invitePublishedTime: 'Published at',
    inviteDeleteInvitee: 'Delete',

    registrationInvites: 'Invites Required',
    registrationInviteRequiredHeader: 'Invitation Requirement',
    registrationInviteRequiredCheckboxMessage: 'Require Invites to Register',
    registrationInviteRequiredDescr:
      'If selected, registration will be closed to the public and only accessible via an invitation.',
    invitationRequiredToRegister: 'Invitation Required for Registration',
    invalidInviteCodeHeader: 'Invalid Invitation Code',
    invalidInviteCodeText: 'This code has already been used or does not match the intended recipient.',

    publishWarningHeader: 'Competition is unpublished',
    publishWarningDescr:
      'This feature is not available until your competition is published.',
    invitationFormNullDivWarning:
      'Are you sure you don\'t want to assign a division?',
    invitationFormInviteEmailAddress: 'Email Addresses',
    invitationFormInvitePrevComps: 'From Previous Competition',
    invitationRegistrantSelectCompHeader: 'Competition',
    invitationRegistrantSelectCompDescr:
      'Select the competition to invite registrants from',
    invitationRegistrantSelectDivHeader: 'Division',
    invitationRegistrantSelectDivDescr:
      'Select the division to invite registrants from',
    invitationLoadDivisions: 'Loading divisions...',
    invitationLoadRegistrants: 'Loading registrations...',
    invitationRegSelectorHead: 'Registrations',
    invitationRegSelectorDescr: 'Registrations are ordered by their leaderboard placement in <strong>{source_comp}</strong>',
    invitationSelectTop: 'Select Top',
    invitationSelectTopDescr:
      'Select all registrants or enter a number to select the top X athletes to be added to this campaign.',
    invitationNoRegistrants: 'There are no registrations in this division.',
    leaderboardSettingsSubHeader:
      'Customize your leaderboard by adjusting the following settings.',
    leaderboardFlagEnabledMessage:
      'Quando alternado, exibe a bandeira do país do atleta. Se o atleta não definir seu país em seu perfil, nenhuma bandeira será exibida.',
    sponsorship: 'Patrocínio',
    sponsors: 'Patrocinadores',
    manageSponsors: 'Gerenciar patrocinadores',
    sponsorsSubHeader:
      'Crie patrocinadores, adicione links de afiliados e faça upload de recursos de imagem para uso em campanhas publicitárias.',
    addSponsor: 'Adicionar patrocinador',
    sponsorName: 'Nome do Patrocinador',
    sponsorNameDescr: 'O nome oficial do seu patrocinador.',
    sponsorLink: 'URL do site',
    sponsorLinkDescr:
      'Forneça um link para seu patrocinador. Quando um espectador clica na imagem do patrocinador no local do anúncio, ele é enviado para o link fornecido.',
    sponsorLogo: 'Logotipo',
    sponsorLogoDescr:
      'Faça o upload de um logotipo para o seu patrocinador que aparecerá nas campanhas publicitárias. Recomendamos uma imagem transparente com as seguintes dimensões: {width}x{height}. É necessária uma imagem para criar um patrocinador.',
    sponsorDeleteDescr:
      'O patrocinador será removido de todos os carrosséis ou campanhas publicitárias existentes aos quais foi atribuído.',
    adCarousels: 'Carrosséis de anúncios',
    manageAdCarousels: 'Gerenciar carrosséis',
    adCarouselsSubHeader:
      'Crie seus carrosséis de anúncios e preencha-os com seus recursos de patrocinador. Um carrossel de anúncios é uma lista de logotipos de patrocinadores que gira em intervalos regulares.',
    addAdCarousel: 'Adicionar carrossel',
    adCarouselMuteLogosDescr: 'Os logotipos do patrocinador serão esmaecidos.',
    adCarouselName: 'Nome do carrossel',
    adCarouselNameDescr: 'O nome do carrossel',
    adCarouselSponsorsDescr:
      'Arraste e solte patrocinadores para a área de preparação do carrossel abaixo. Se o pedido estiver ativado, os patrocinadores serão mostrados de cima para baixo.',
    adCarouselStage: 'Palco carrossel',
    adCarouselSponsorsOrderDescr:
      'Os patrocinadores devem ser exibidos na ordem especificada.',
    adCarouselPreview: 'Pré-visualização do carrossel',
    adCarouselDeleteDescr:
      'A exclusão deste carrossel também excluirá as campanhas de anúncios às quais está atribuído.',
    adCampaigns: 'Campanhas de anúncios',
    manageAdCampaigns: 'Gerenciar campanhas de anúncios',
    adCampaignsSubHeader:
      'Crie suas campanhas de anúncios, atribua seus carrosséis de anúncios, selecione em quais páginas públicas seus carrosséis de anúncios serão exibidos e configure os horários em que são exibidos.',
    addAdCampaign: 'Adicionar campanha',
    adCampaignName: 'Nome da campanha',
    adCampaignNameDescr: 'Forneça um nome para a campanha',
    adCampaignCarousel: 'Carrossel',
    adCampaignCarouselDescr:
      'Selecione o carrossel a ser usado para esta campanha',
    adCampaignPages: 'Páginas',
    adCampaignAddAllPages: 'Adicionar a todas as páginas disponíveis',
    adCampaignPagePreview: 'Preview',
    adCampaignPagesDescr:
      'Selecione todas as páginas disponíveis ou escolha seções específicas de cada página',
    adCampaignDates: 'Datas',
    adCampaignDatesDescr:
      'Selecione uma data e hora para iniciar e encerrar sua campanha. O carrossel será exibido apenas nas páginas selecionadas se a data e a hora atuais estiverem dentro desse período.',
    adCampaignConflictingCampaigns: 'Campanhas conflitantes',
    adCampaignConflictingCampaignsWarning:
      'Você não pode salvar esta campanha porque entraria em conflito com as seguintes campanhas:',
    adCampaignConflictingPagesWarning:
      'Essas campanhas compartilham as seguintes seções da página da campanha em um período de sobreposição:',
    adCampaignNoCarousels: 'Não há carrosséis de anúncios disponíveis. Crie um usando a <a href="/app/competitions/{competitionId}/setup/marketing/ad-carousels/">Página de carrosséis de anúncios</a>.',
    adCampaignsReport: 'Relatório de anúncio',
    filter: 'Filter',
    adCampaignsFilterDescr:
      'Filtrar por campanha, carrossel ou seção da página',
    carousel: 'Carrossel',
    pageSlots: 'Seções da página',
    selectCampaign: 'Selecione uma campanha ...',
    selectCarousel: 'Selecione um carrossel ...',
    selectPageSection: 'Selecione uma seção da página ...',
    ticketLinks: 'Links de tickets',
    ticketer: 'Ticketer',
    pageNotFound: 'Não foi possível encontrar essa página.',
    pleaseCheckLinkAgain:
      'Verifique o link para esta página novamente e verifique se está correto.',
    noPermission: 'Você não tem permissão para ver isso.',
    publishHeatAssignments: 'Publish Heat Assignments',
    areYouSurePublishHeatAssignments: 'Are you sure?',
    heatAssignmentPublishWarning:
      'After publishing, athletes will see their assignments on their personal schedule.',
    unpublishHeatAssignments: 'Unpublish Heat Assignments',
    areYouSureUnpublishHeatAssignments: 'Are you sure?',
    unpublishHeatAssignmentsWarningIntro:
      'This will remove heat assignments from public view of schedules',
    unpublishHeatAssignmentsWarningBody: '',
    confirmUnpublishHeatAssignments: 'Yes, Unpublish Heat Assignments',
    ticketing: 'Ticketing',
    spectators: 'Spectators',
    manageAssignmentsInfo:
      'Expand your segments to have access to manually select the heat/lane for each athlete',
    competitionLandingDefaultDescr: '<h1><span style="color: rgb(36, 41, 46);">Bem-vindo ao {competitionName}!</span></h1><p><br></p><p><span style="color: rgb(36, 41, 46);">Estamos emocionados por querer participar do nosso evento. Informações sobre a data da competição, exercícios e divisões podem ser encontradas em nossa página de destino. A partir daqui, você também pode se registrar, visualizar tabelas de classificação, comprar ingressos e muito mais!</span></p><p><br></p><p><span style="color: rgb(36, 41, 46);">Se você tiver alguma dúvida, entre em contato com <a href="mailto:{competitionEmail}">{competitionEmail}</a> para obter assistência.</span></p>',
    hashtagsPlaceholder: 'Adicione hashtags...',
    defaultHashtags: 'Hashtags Sugeridas',
    hashtags: 'Hashtags',
    organizerHashtagExplanation:
      'Os atletas podem usar hashtags para competir com grupos menores em um placar personalizado.<br/>Digite uma lista de hashtags que serão sugeridas aos seus atletas no momento da inscrição.',
    myHashtagsDescr:
      'Use hashtags para competir com seu grupo em um ranking personalizado (#ginástica, #ganhando, etc.)',
    advancedFilters: 'Pesquisa e filtro',
    applyFilters: 'Aplicar Filtros',
    clearFilters: 'Limpar Filtros',
    noMatchingAthletes:
      'Não há atletas que correspondam aos filtros fornecidos.',
    filterEntriesFound: 'atletas encontrados nesta tabela de classificação.',
    canFilterLeaderboardLabel: 'Use para filtrar o cabeçalho',
    canFilterLeaderboardDescr:
      'Esta pergunta pode ser usada para filtrar tabelas de classificação para grupos menores de atletas.',
    iJustRegistered: `Acabei de me registrar no {compName} em ${SHORT_DOMAIN}!`,
    shareYourRegistration:
      'Faça o download e compartilhe esta imagem para informar seus amigos que você se registrou!',
    iJustScored: `Acabei de registrar uma pontuação de {score} para {workout}. Confira as tabelas de classificação de {compName} em ${SHORT_DOMAIN}!`,
    shareYourScore:
      'Baixe esta imagem e compartilhe sua pontuação com seus amigos!',

    howToFilterModalTitle: 'Você sabia?',
    howToFilterModalBody:
      'Você pode procurar um atleta ou criar uma tabela de classificação apenas com você e seus amigos, clicando em "Pesquisar e filtrar".',
    howToFilterModalButton: 'Entendi!',

    howToShareModalTitle: 'Compartilhe seu cabeçalho personalizado',
    howToShareModalBody:
      'Compartilhar esse cabeçalho personalizado é tão fácil quanto copiar e colar o endereço da web!',
    howToShareModalButton: 'Entendi!',

    leaderboardAutoPublishTurnedOn:
      'A publicação automática do placar foi ATIVADA. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Atualizar Configurações</a>',
    leaderboardAutoPublishTurnedOff:
      'A publicação automática de placares foi DESATIVADA. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Atualizar Configurações</a>',

    trials: {
      oneDayTrial: 'Experimente gratuitamente agora mesmo!',
      yourTrialExpired: 'Seu teste expirou',
      nocc: 'Não é necessário cartão de crédito',
      activate: 'Ativar!',
      weSentARequest:
        'Enviamos uma solicitação ao seu representante de conta para ativar esse recurso. Eles entrarão em contato em breve!',

      sponsorship: {
        img:
          'https://strongest.com/wp-content/uploads/2020/03/throwdowns-marketing-1024x525.png',
        icon: 'rectangle-ad',
        title: 'Kit de Patrocínio',
        description:
          'Desbloqueie colocações de logotipo exclusivas para seus patrocinadores e suas marcas! Este kit permite que você crie conteúdo de patrocínio personalizado em páginas importantes para aumentar a receita e manter seus patrocinadores felizes.',
        features: [
          {
            icon: 'conveyor-belt-boxes',
            copy:
              'Crie logotipos rotativos de patrocinadores nas páginas de competição mais visualizadas.'
          },

          {
            icon: 'chart-line',
            copy:
              'Garanta o valor do patrocinador com URLs personalizáveis ​​em seus logotipos para rastrear visualizações de páginas e taxas de cliques.'
          },

          {
            icon: 'dollar-sign',
            copy:
              'Aumente a receita de sua competição atraindo novos patrocinadores!'
          }
        ]
      },

      scheduling: {
        img:
          'https://strongest.com/wp-content/uploads/2020/03/throwdowns-scheduling-1024x587.jpg',
        icon: 'stopwatch',
        title: 'Kit de Agendamento',
        description:
          'A programação de calor é geralmente uma “pegadinha” de última hora que os organizadores pensam tarde demais. Com este kit, você pode construir e publicar sua programação para que todos saibam o quê / onde / quando para cada momento de sua competição. Seus atletas, fãs, voluntários e equipe irão agradecer.',
        features: [
          {
            icon: 'clock',
            copy:
              'Crie programações que são perfeitamente integradas com nossos sistemas de registro e pontuação.'
          },

          {
            icon: 'table',
            copy:
              'Calcule e gerencie horários dentro do aplicativo - sem planilhas separadas!'
          },

          {
            icon: 'users',
            copy:
              '“Reseed” seus atletas sem dor com nosso Scheduler feito sob medida.'
          }
        ]
      },

      liveScoring: {
        img:
          'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'table-list',
        title: 'Kit de Pontuação ao Vivo',
        description:
          'Aproveite as ferramentas necessárias para atrair espectadores de todo o mundo para sua competição. Veja os resultados à medida que acontecem em tempo real, sem esperar que a bateria termine. Capacite os comentaristas a contar E mostrar uma ótima história com resultados relevantes baseados em dados e ação ao vivo na tela.',
        features: [
          {
            icon: 'award',
            copy:
              'Atualizar continuamente os placares de cada bateria em tempo real.'
          },
          {
            icon: 'tv',
            copy:
              'Gráficos orientados a dados publicam resultados em telas de relógio, dispositivos móveis ou fitas de pontuação no topo da tela.'
          },
          {
            icon: 'dollar-sign',
            copy:
              'Maximize a receita de ingressos, espectadores online e patrocinadores.'
          }
        ]
      },

      precisionTiming: {
        img:
          'https://strongest.com/wp-content/uploads/2020/05/throwdowns-precision-timing.png',
        description:
          'Deixe seus atletas terminarem com força, com uma ação enfática que não apenas entretém, mas oferece precisão. Nosso kit de temporização de precisão inclui os botões, bem como integração de última geração com temporizadores de chip para garantir que você execute um evento de primeira linha com temporização precisa de 1/100 de segundo. Chega de disputas por erro humano, chega de adivinhação: apenas finalizações espetaculares e agradáveis ​​ao público.',
        title: 'Kit de sincronização de precisão',
        features: [
          {
            icon: 'stopwatch',
            copy:
              'Garanta a precisão sem o risco de erro de sincronização humano.'
          },
          {
            icon: 'trophy',
            copy:
              'Crie acabamentos emocionantes e dignos de destaque apertando um botão ou cruzando a linha de chegada com chips de tempo.'
          },
          {
            icon: 'award',
            copy:
              'Pareça profissional com rastreamento de resultados automatizado e baseado em tecnologia'
          }
        ]
      },

      broadcasting: {
        img:
          'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'tv',
        title: 'Kit de Transmissão',
        description:
          'Nosso kit de transmissão oferece gráficos de qualidade de rede que se conectam perfeitamente com feeds de dados de nossos sistemas de pontuação ao vivo e de informações de comentaristas. Cada segundo que passa é precioso durante uma produção ao vivo, portanto, otimizamos o software e os fluxos de trabalho para que você possa obter a produção da mais alta qualidade com uma fração do esforço normal necessário.'
      }
    },

    siteContent: {
      topLevelHelp: '<div class="content"><h2>Bem-vindo</h2><p><br></p><p>Ao interagir em competições, você verá um ícone <strong>?</strong> de ajuda (igual àquele que está selecionado no menu à esquerda) que fornece ajuda direcionada a respeito do funcionamento de cada parte do aplicativo.</p><p><br></p></div>',

      compSetupMarketing: '<div class="content"><h1>Marketing</h1><p>Abaixo das abasde <strong>Marketing</strong>, você pode personalizar quase todos os principais aspectos de marketing da sua competição.</p><ul><li>A aba <strong>Configuração</strong> tem todas as informações de alto nível a respeito da competição, como o nome, site e foto da capa. </li><li>A aba de <strong>Conteúdo</strong> é onde você poderá editar o conteúdo da página inicial. Essa é a primeira página que os usuário vão ver quando entrarem na sua competição e a principal página que você irá divulger na mídia social ou para fazer o marketing da sua competição.</li><li>A aba <strong>Tempo e Lugar</strong> é onde você pode estabelecer o local e endereço das competições ao vivo. Você também pode determiner a data oficial e o fuso horário da competição a partir dessa opção de menu.</li><li>Se a sua competição permite aos atletas enviarem sua própria pontuação, você poderá mexer nas configurações de envio de pontuação na aba <strong>Pontuação Online</strong>.</li></ul><p>Confira nossa <a href="http://help.strongest.com/pt/">Central de Ajuda</a></a> para obter mais artigos de suporte sobre o marketing do seu evento.</p></div>',

      compSetupProgramming: '<div class="content"><h1>Programação</h1><p>Na subguia <strong> Programação</strong>, você pode personalizar todos os aspectos das divisões, exercícios e políticas de pontuação da sua competição.</p><ul><li>As guias <strong> Divisões </strong> e <strong> Exercícios </strong> permitem gerenciar todas as configurações diferentes para suas divisões e exercícios.<ul><li>Em cada divisão / treino, você pode adicionar / remover entradas, incorporar conteúdo (incluindo imagens e vídeos) e definir detalhes avançados, como limites de registro por divisão, número total de membros da equipe ou tempos de liberação do treino.</li><li>Recomendamos que você inclua padrões de movimento claros para cada treino e uma breve descrição para cada divisão.</li></ul></li><li>A guia <strong> Políticas de Pontuação </strong> é onde você pode definir regras específicas sobre como a pontuação é calculada.</li><ul><li>O <strong> Tipo de pontuação </strong> afeta todas as divisões e exercícios e determina a colocação geral do atleta na tabela de classificação. Recomendamos o uso de pontuação baseada em posicionamento ou as tabelas de pontos padrão do CrossFit® Games. Você pode aprender mais sobre esses tipos de pontuação em <a href="http://help.strongest.com/pt/articles/3062621-choosing-your-scoring-policies"> neste artigo de ajuda</a>.</li><li>Para exercícios, você designará que um valor mais alto da pontuação é melhor (por exemplo, AMRAP, elevações máximas de esforço etc.) ou um valor mais baixo da pontuação é melhor (exercícios com base no tempo.) Você pode definir políticas de desempate, contagem de representantes, e limites de tempo aqui também.</li></ul></ul><p>Lembre-se: a chave para uma ótima programação é a simplicidade. Quanto mais fácil for para os atletas entenderem os padrões e como a pontuação funciona, melhor!</p><p>Confira nossa <a href="http://help.strongest.com/pt/"> Central de Ajuda</a> para obter mais artigos de suporte sobre como criar sua programação de competições ou configurar suas políticas de pontuação.</p></div>',

      compSetupRegistration: '<div class="content"><h1>Registro</h1><p>Nas subguias <strong>Registro</strong>, você pode personalizar toda a experiência de registro para seus atletas e voluntários.</p><ul><li>A guia <strong>Conteúdo</strong> é onde você pode personalizar o conteúdo que o usuário verá quando chegar à sua página de registro. Você pode inserir texto, bem como incorporar imagens e vídeo.</li><li>A guia <strong>Taxas</strong> é onde você pode especificar os preços dos ingressos e a moeda a ser usada na finalização do atleta.</li><li>A guia <strong>Varejo</strong> é onde você pode criar e gerenciar itens de mercadoria adicionais a serem oferecidos no registro. Você pode definir o nome, preço e quantidade de mercadoria.  </li><li>A guia <strong>Datas</strong> é onde você pode configurar as datas e os horários de abertura / fechamento do registro. Lembre-se de que as configurações de fuso horário se aplicam aqui. Você pode alterá-las no menu Marketing, conforme necessário.</li><li>A guia <strong>Depósitos</strong> mostra a conta do Stripe à qual a competição está conectada. Sua conta do Stripe é onde você receberá depósitos à medida que seus atletas se registram.</li></ul><p>Confira nossa <a href="http://help.strongest.com/pt/">Central de Ajuda</a> para obter mais artigos de suporte sobre como personalizar seu registro e gerenciar seus registrantes.</p></div>',

      compSetupAdvanced: '<div class="content"><h1>Configurações Avançadas</h1><p>As subguias <strong> Avançadas </strong> contêm vários recursos extras que podem ser usados para personalizar ainda mais sua experiência na competição, principalmente no registro.</p><ul><li>Se você gostaria de oferecer cupons para seus atletas, você pode fazê-lo na aba de <strong>Cupons</strong>. Você pode criar cupons com uma variedade de restrições, tais como valores fixo ou baseado em porcentagem para desconto do ticket, datas de validade, números limitados de cupons, etc.</li><li>A aba de <strong>Desistência Personalizada</strong> te permite criar uma desistência personalizada para registro. Nós provemos um conteúdo padrão, mas sempre recomendamos que você o revise cuidadosamente e use seu próprio caso tenha um que já foi revisado pela sua equipe legal.</li><li>Você pode adicionar <strong>Campos Personalizados</strong> em seu formulário de registro caso tenha alguma informação adicional que você queira receber dos atletas. Por exemplo, alguns organizadores gostam de perguntar aos atletas como eles ouviram sobre a competição ou estão competindo pela primeira vez. Esta informação pode ser vista na aba de exportação de <strong>Inscritos </strong>.</li><li>É improvável que você precisará fazer mudanças na sub-abas <strong>Política de Pontuação Avançada</strong>. Caso você veja que sua competição tem uma pontuação especial que a configuração padrão não cubra, nos contate, e nós ficaremos felizes em ajudar com a configuração avançada.</li><li>O <strong> Limite de Registro </strong> é onde você pode definir um limite global para o número de atletas inscritos permitidos para sua competição.</li> <li><strong> Acesso ao registro </strong> determina se seus registrantes têm a capacidade de atualizar o registro deles no painel. Isso é ativado por padrão. Se desativado, os atletas não poderão atualizar seu registro após o pagamento.</li><li>A alternância de <strong> Convites Necessários </strong> bloqueará o registro e exigirá que os registrantes tenham um convite para se registrar. Os convites são enviados pela guia <strong> Convites</strong>.</li></ul><p>Confira nossa <a href="http://help.strongest.com/pt/"> Central de Ajuda </a> para obter mais artigos de suporte sobre esses recursos avançados.</p></div>',

      compRegistrants: '<div class="content"><h1>Inscritos</h1><p>A sub-abas de <strong>Inscritos </strong>contém relatórios simples que mostram quem tem o registro para sua competição por divisão.</p><p>Existem algumas outras funções também:</p><ul><li>Você pode visualizar o nome dos atletas, e-mails, data de registro, e mudanças de registro. </li><li>Você pode editar um nome do placar do atleta e mudar sua divisão. </li><li>Você pode exportar dados de registro de todas as divisões.</li></ul><p>O <strong>Solicitar Exportação</strong> no canto superior direito te permite tirar um “snapshot" e exportar toda a informação de registro do atleta. Quando estiver pronto, o aplicativo enviará um e-mail contendo um arquivo csv de todos os seus registrantes para facilitar o armazenamento e a análise.</p></div>',

      compScoring: '<div class="content"><h1>Entrada de Pontos e Revisão</h1><p><br></p><ul><li><span style="background-color: transparent;">As sub-abas </span>de <strong style="background-color: transparent;">Entrada de Pontos</strong><span style="background-color: transparent;"> servem para você gerenciar os pontos para cada de suas divisões.</span></li><li><span style="background-color: transparent;">Você pode usar </span> a aba de <strong style="background-color: transparent;">Links de Entrada de Dados</strong><span style="background-color: transparent;"> para criar e compartilhar os links de "quiosque de Entrada de Pontos" com as pessoas que você gostaria de escalar como delegado. Tipicamente, estas pessoas serão membros da sua equipe que é o chaveamento em pontuações quando os cartões de pontuação de papel chegam a mesa de pontuação.</span></li><li><span style="background-color: transparent;">Na sub-aba de cada divisão, você pode chavear os pontos e pré-visualizar como o placar ficará quando os pontos forem registrados. No entanto, o público do placar oficial não atualizará até você atualizar o placar.</span></li><li><span style="background-color: transparent;">Muitas competições vão preferir ter a "grande revelação" no final da competição logo antes da cerimônia de premiação, e poder ver o placar antes de publicar pode ser útil aqui.</span></li><li><span style="background-color: transparent;">Os dados dos atletas manualmente inseridos podem ser removidos da tabela de pontuação ao deletar seus nomes. Isso removerá toda a pontuação inserida também. &nbsp;</span></li><li><span style="background-color: transparent;">Se sua competição envolve pontuação online, você poderá revisar (aprovar/rejeitar) todos os pontos que são submetidos por atletas com a ferramenta de revisão de pontos que estão sob os menus de nível de divisão.</span></li><li><span style="background-color: transparent;">Envio da pontuação Online que foram aprovados serão automaticamente atualizados ao placar público depois de um certo tempo (a cada 5 minutos).</span></li></ul><p><br></p></div>',

      compSupport: '<div class="conteúdo"><h1>Suporte</h1><p><br></p><p><span style="background-color: transparent;">Todos os suportes são organizados: </span><strong style="background-color: transparent;">Configuração</strong><span style="background-color: transparent;">, </span><strong style="background-color: transparent;">Gerenciamento</strong><span style="background-color: transparent;">,</span><strong style="background-color: transparent;"> </strong><span style="background-color: transparent;">e </span><strong style="background-color: transparent;">Suporte</strong></p><ul><li><span style="background-color: transparent;">Cada aba sob </span><strong style="background-color: transparent;">Configuração </strong><span style="background-color: transparent;">as seções te permitem modificar as configurações que você tinha configurado durante o processo de passo a passo. Uma vez configurado apropriadamente, você provavelmente não precisará voltar e interagir com elas quando sua competição for lançada.</span></li><li><span style="background-color: transparent;">Cada aba sob </span><strong style="background-color: transparent;">Gerenciamento </strong><span style="background-color: transparent;">a seção involve operações diárias para sua competição.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Por exemplo, você provavelmente estará de olho nos registros sob os </span><strong style="background-color: transparent; color: rgb(33, 35, 41);">Inscritos </strong><span style="background-color: transparent; color: rgb(33, 35, 41);">aba como registros preenchidos.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Para eventos online, você também precisa inserir </span>aba de <strong style="background-color: transparent; color: rgb(33, 35, 41);">Entrada de Pontos</strong><span style="background-color: transparent; color: rgb(33, 35, 41);"> para revisão das pontuações como fechamento da janela de treino.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Para eventos em locais fechados ao vivo, sua mesa de pontuação será a entrada em pontuação </span>aba de <strong style="background-color: transparent; color: rgb(33, 35, 41);">Entrada de Pontos</strong><span style="background-color: transparent; color: rgb(33, 35, 41);"> no decorrer dos dias da competição.</span></li><li><strong style="background-color: transparent;">A seção de Suporte </strong><span style="background-color: transparent;">será onde nós continuamos a criar e porver um suporte único para melhor ajudar a tocar sua competição!</span></li><li class="ql-indent-1"><span style="background-color: transparent;">Lembre, você pode sempre nos contatar pelo Intercom, o pequeno ícone de texto em preto no canto inferior direito da tela.</span></li></ul><h2> Video de início rápido</h2><p><br></p><p>Aqui está um video curto de ~2.5 minutos que criamos para te dar uma rápida orientação de como o sistema funciona.</p><p><br></p><iframe class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/yaTL8CPR21s?showinfo=0"></iframe><p><br></p><p><br></p></div>',

      compSetupHeatScheduling: `<div class="content"><h1>Agendamento Heat</h1><p><br><strong>Bem-vindo à página de ajuda para criar agendas heat!</strong></p><p>Sabemos que criar uma programação a partir do zero pode ser uma tarefa difícil e demorada. É por isso que criamos uma ferramenta intuitiva e fácil de usar para ajudá-lo a criar, gerenciar e compartilhar sua agenda de heat no ecossistema do ${APP_NAME}.</p><p>Para começar a criar sua programação, pedimos que você primeiro consulte nosso assistente de configuração. Esse formato facilita a decomposição e a elaboração das diferentes partes de um cronograma.</p><p>Recomendamos fortemente que também consulte o nosso centro de ajuda para obter um guia completo sobre tudo o que precisa de saber sobre o nosso agendador. Os artigos de ajuda são projetados para não apenas ajudá-lo nas partes técnicas da criação de sua agenda, mas também para reforçar as melhores práticas e padrões usados por competições profissionais em todo o mundo.</p><p>Se você tiver alguma dúvida ou precisar de ajuda para configurar sua agenda, não hesite em entrar em contato conosco!</p></div>`,

      compInvitations: '<div class="content"><h1>Invitations</h1><p><strong>Welcome to the help page for Invitations!</strong></p>Through the Invitations tab, you can email invitations to your athletes, volunteers, and spectators so they can register for your event.<p><p>Some of the features include:</p><ul><li>Ability to adjust the messaging in your invitation</li><li>Dynamic invite system that sends invites in the specific order you set</li><li>Functionality for inviting users to specific divisions.</li><li>Tracking metrics so you know whether an invite has been accepted, expired, or if the email address provided is invalid.</li></ul><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for specific support articles regarding Invitations.</div>',

      compLeaderboards: '<div class="content"><h1>Preferências de exibição do cabeçalho</h1> <p><strong>Bem-vindo à página de ajuda das Preferências de exibição do cabeçalho!</strong></p>Esse recurso permite que você defina as várias configurações de exibição que deseja para seus placares.<p><p>Algumas das preferências de exibição atuais e futuras das tabelas de classificação são:</p><ul><li>Capacidade de exibir as bandeiras dos países registrantes</li><li>(Em breve!) Capacidade de exibir o afiliado nomes de registrantes</li><li>(Em breve!) Capacidade de alternar entre os links dos vídeos de envio de pontuação para aparecer na tabela de classificação</li><li>E mais!</li></ul><p> Continuar a criar definições de configuração, elas aparecerão aqui.</p><p>Se você estiver tentando visualizar ou publicar suas tabelas de classificação, faça isso na guia <strong>Pontuação da entrada</strong>, não nesta guia. <p> Confira nossa <a href="http://help.strongest.com/pt/">Central de Ajuda</a> para obter artigos de suporte que fornecem exemplos de nossas diferentes opções de exibição no cabeçalho.</div>',

      compSetupTicketing: '<div class="content"><h1>Ingressos</h1><p><strong>Bem-vindo à página de ajuda para criar ingressos para o seu evento!</strong></p>Esse recurso permite que você crie, edite e gerencie os diferentes ingressos que você oferecerá aos seus espectadores.<p><p>Existem 3 sub-abas principais:</p><ul><li>A guia <strong>Conteúdo</strong> permite que você personalize o texto que aparecerá na parte superior da página de compra de ingressos.</li><li>A guia <strong>Datas</strong> é onde você definirá a data de início para quando os ingressos estiverem à venda e a data final para quando os ingressos não estiverem mais disponíveis para compra.</li><li>A guia <strong>Ingressos</strong> é onde você cria, edita e exclui suas opções de ingresso. Nesta guia, você pode configurar o preço, quantidade, nome e descrição dos seus vários ingressos.</li></ul><p>Cada ingresso vendido é fornecido com um código QR exclusivo enviado ao comprador no aplicativo e por e-mail. Esse código QR facilita a validação de ingressos para entrada durante seu evento ao vivo.</p><p>À medida que seus ingressos são comprados, seus espectadores e seus ingressos serão preenchidos na guia <strong> Espectadores </strong> de nível superior. </p><p>Consulte nossa <a href="http://help.strongest.com/pt/"> Central de Ajuda </a> para obter artigos de suporte específicos sobre tickets.</p></div>',

      compSpectators: '<div class="content"><h1>Espectadores</h1><p><strong>Bem-vindo à página de ajuda para gerenciar seus espectadores!</strong></p>A subguia <strong>Espectadores</strong> contém um relatório simples sobre os vários ingressos que foram comprados para o seu evento.<p><p>Nesta guia, você pode:</p><ul><li>Visualize informações básicas de contato dos titulares de ingressos, como nome e email.</li><li>Veja o tipo de bilhete comprado, seu ID exclusivo e o status atual de resgate.</li><li>Filtre os resultados por nome, email ou ID do ingresso.</li></ul><p>Cada ingresso vendido é fornecido com um código QR exclusivo enviado ao comprador no aplicativo e por e-mail. Esse código QR facilita a validação de ingressos para entrada durante seu evento ao vivo. </p><p>Confira nossa <a href="http://help.strongest.com/pt/">Central de Ajuda</a> para obter artigos de suporte específicos sobre ingressos para espectadores.</p></div>'
    },
    setADateRange: 'Definir um intervalo de datas',
    clearDateRange: 'Limpar intervalo de datas',
    selectAll: 'Selecionar tudo',
    selectNone: 'Selecione nenhum',
    close: 'Perto',
    issueLoadingPaymentForm: 'Ocorreu um problema ao carregar o formulário de pagamento. Por favor atualize.',
    uploading: 'Enviando...',
    imageTooBig: 'Essa imagem é muito grande. O limite é 5 MB.',
    uploadImage: 'Faça upload de uma imagem',
    clearImage: 'Imagem clara',
    youtubeEmbed: 'YouTube Embed',
    addVideo: 'Adicionar vídeo',
    loadingCompetition: 'Carregando competição',
    draft: 'Rascunho',
    readyToPublish: 'Você está pronto para publicar sua competição?',
    yesPublish: 'Sim, publique!',
    pleaseEnterAValidEmail: 'Por favor insira um endereço de e-mail válido.',
    competition: 'Concorrência',
    id: 'identificação',
    youllBeNotifiedWhenYourExportIsReady: 'Você será notificado em breve por e-mail quando a exportação estiver pronta.',
    deleted: 'Excluído',
    noVideo: 'Nenhum vídeo',
    url: 'URL',
    youtubeUrlDesc: 'O URL do vídeo do YouTube',
    image: 'Imagem',
    scoreRejection: 'Pontuação de rejeição',
    scoreRejectionDesc: 'Você está rejeitando uma pontuação enviada por um atleta. Isso ocultará a pontuação na tabela de classificação, como se nenhuma pontuação tivesse sido enviada.',
    rejectReason: 'Motivo de rejeição',
    rejectReasonDesc: 'Deixe um comentário explicando porque a pontuação foi rejeitada. Isso ajudará o atleta a entender por que seu envio de pontuação foi rejeitado',
    rejectAndEmailAthlete: 'Rejeitar e enviar e-mail ao atleta',
    unreject: 'Não rejeitar',
    reject: 'Rejeitar',
    unverify: 'Cancelar a verificação',
    verify: 'Verificar',
    evidence: 'Provas',
    noEvidence: 'Sem provas',
    showingTopOneHundredAthletes: 'Mostrando os 100 melhores atletas. Use a pesquisa para encontrar qualquer atleta a fim de inserir / modificar suas pontuações.',
    nameOrBibNumber: 'Nome ou número do Bib',
    spectatorFilterDesc: 'Filtrar por nome, e-mail ou id do tíquete',
    acceptRegistrationWaiver: 'Aceitar renúncia de registro',
    appWaiver: `Renúncia de ${APP_NAME}`,
    compWaiver: 'Dispensa de Concorrência',
    yesIAgree: 'Yes, I agree',
    yesIAgreeToBoth: 'Sim eu concordo com ambos',
    searching: 'Procurando...',
    stoppedAt: 'Parado em',
    seeMore: 'Ver mais',
    groupLeaderboards: 'Placares de Grupo',
    groupLeaderboardsDesc: 'Crie tabelas de classificação combinadas agregando atletas em divisões específicas.',
    divisionsMustHaveSameWorkouts: 'As divisões selecionadas devem ter os mesmos treinos',
    showCountryFlag: 'Mostrar bandeira do país',
    enableAutoPublish: 'Habilitar Publicação Automática',
    autopublishDesc: 'Quando ativado, seu placar será publicado automaticamente se houver alguma alteração, pelo menos a cada 10 minutos.',
    showVideoOrImage: 'Mostrar links de vídeo / imagem',
    showVideoOrImageDesc: 'Quando alternados, os links de vídeo / imagem são exibidos na tabela de classificação para todas as pontuações que têm um vídeo ou imagem enviada. Caso contrário, vídeos ou imagens só podem ser vistos pela equipe organizadora na tabela de pontuação.',
    discountedSubtotal: 'Subtotal com desconto',
    teamMembersCantShareEmails: 'Os membros da equipe não podem compartilhar endereços de e-mail, pois cada membro precisará fazer o login e assinar uma renúncia.',
    needsToSignWaiver: 'Precisa Assinar Renúncia',
    time: 'Tempo',
    unpublishing: 'Cancelando a publicação ...',
    noScore: 'Não há pontuação',
    typeAthleteAutosuggest: 'Digite o nome do atleta para seleção de autocompletar para acessar seus cartões de pontuação.',
    capIsGreaterThanDivisionCaps: 'Embora esse limite seja válido, seu valor é maior do que a soma de todos os limites de divisão e, portanto, nunca terá qualquer efeito visível.',
    schedulePreview: 'Antevisão da Programação',
    thisRegeneratesAllHeatsWarning: 'Isso irá regenerar completamente as baterias para esta seleção, perdendo todas as edições manuais feitas. Tem certeza?',
    yesRegenerateAllHeats: 'Sim, regenere baterias',
    regenerateAllHeats: 'Regenere baterias',
    generateHeats: 'Gerar Calor',
    filterDivisionsDesc: 'Selecione uma divisão para filtrar',
    allDivisions: 'Todas as Divisões',
    filterWorkoutsDesc: 'Selecione um treino para filtrar',
    allWorkouts: 'Todos os treinos',
    editHeat: 'Editar Calor',
    heatTitleDesc: 'Título da bateria para exibição da programação',
    startTime: 'Hora de início',
    pickAStartTime: 'Escolha um horário de início',
    endTime: 'Fim do tempo',
    pickAnEndTime: 'Escolha um horário de término',
    moving: 'Movendo ...',
    moveHeats: 'Mova 1 calor aqui | Mova {n} aquece aqui',
    doneEditing: 'Terminar a edição',
    recalculateAssignments: 'Recalcular atribuições',
    updateFromLeaderboard: 'Atualização da Tabela de Líderes',
    noScoresPublished: 'Nenhuma pontuação publicada',
    regenerateHeats: 'Regenerar baterias',
    updateManually: 'Atualizar manualmente',
    seeding: 'Semeando',
    reset: 'Redefinir',
    saved: 'Salvou',
    clear: 'Claro',
    addJudge: 'Adicionar Juiz',
    emptyLane: 'Pista Vazia',
    swapping: 'Trocando ...',
    cancelSwap: 'Cancelar troca',
    swap: 'Trocar',
    addBack: 'Adicionar Voltar',
    addingBack: 'Adicionando de volta ...',
    removing: 'Removendo ...',
    yesRemove: 'Sim, remover',
    remove: 'Remover',
    hasMultipleRegistrations: 'tem vários registros',
    working: 'Trabalhando...',
    yesClearTodaysSchedule: 'Sim, limpe a programação de hoje',
    youMustHaveAtLeastOneWorkoutLocation: 'Você deve ter pelo menos um local de treino.',
    youMustHaveAtLeastOneDay: 'Você deve ter pelo menos um dia.',
    addDay: 'Adicionar dia',
    locationSchedule: 'Programação de localização',
    viewScheduleByLocation: 'Ver programação por localização',
    viewScheduleByDay: 'View by Day',
    hideContent: 'Esconder o Conteúdo',
    showContent: 'Mostrar conteúdo',
    deleteEvent: 'Apagar Evento',
    areYouSureYouWantToDeleteThisEvent: 'Tem certeza que deseja excluir este evento?',
    editEvent: 'Editar Evento',
    moveToDifferentDay: 'Mude para um dia diferente',
    day: 'Dia',
    moveToDifferentLocation: 'Mover para um local diferente',
    move: 'Mover',
    customize: 'Customizar',
    scheduleStartTimeDesc: 'Escolha um horário de início para o que você está adicionando à programação',
    addToSchedule: 'Adicionar à programação',
    timeBlockTitleDesc: 'Título do bloco de tempo para exibição da programação',
    selectAWorkout: 'Selecione um treino',
    heatScheduleWorkoutDesc: 'Escolha um treino para o qual deseja programar baterias',
    selectADivision: 'Selecione uma divisão',
    heatScheduleDivisionDesc: 'Escolha uma divisão para a qual você deseja agendar eliminatórias',
    eventsToSchedule: 'Eventos para agendar',
    eventsToScheduleDesc: 'Selecione um ou mais eventos para os quais você gostaria de agendar baterias',
    events: 'Eventos',
    timeBlock: 'Bloco de Tempo',
    currentConfiguration: 'Configuração atual',
    scheduleWorkoutTitleDesc: 'O título do local do treino que será exibido na programação',
    scheduleWorkoutDescriptionDesc: 'Conteúdo em rich text que será exibido na programação para este local de treino',
    editTimeBlock: 'Editar Bloco de Tempo',
    pointsTablePreview: 'Antevisão da Tabela de Pontos',
    excludeWorkout: 'Quer excluir este treino da tabela de classificação desta divisão?',
    confirmExcludeWorkout: 'Esta ação removerá o treino desta divisão, bem como sua política de pontuação. Este treino não aparecerá na apresentação da pontuação do atleta, nem na tabela de classificação desta divisão.',
    applyToAllDivisions: 'Quer aplicar essas configurações a todas as divisões deste exercício?',
    confirmApplyToAllDivisions: 'Esta ação aplicará as políticas de pontuação do treino salvas atualmente a TODAS as divisões. Todas as políticas de pontuação existentes para este treino serão substituídas. Isso não afetará os exercícios excluídos.',
    areYouSureYouWantToProceed: 'Tem certeza de que deseja continuar?',
    yesApplyToAll: 'Sim, aplique a todos',
    yesExclude: 'Sim, excluir',
    basicSetup: 'Configuração básica',
    brandIdentity: 'Identidade da marca',
    pleaseLimitSenderName: 'Limite o nome a menos de 50 caracteres e não é um endereço de e-mail.',
    pleaseEnterAValidUrl: 'Por favor, insira um URL válido.',
    theme: 'Tema',
    themeDesc: 'Escolha um tema para alterar o estilo de suas páginas de destino. Você pode personalizar ainda mais um tema selecionando cores que combinam com sua marca.',
    currentTheme: 'Tema Atual',
    themeOptions: 'Opções de temas',
    customizeTheme: 'Personalizar Tema',
    customizeThemeDesc: 'Selecione as cores para substituir o tema {name} para esta competição.',
    primaryBrand: 'Marca Principal',
    primaryText: 'Texto Primário',
    primaryBackground: 'Antecedentes Primários',
    secondaryText: 'Texto Secundário',
    secondaryBackground: 'Fundo Secundário',
    buttonBackground: 'Fundo do botão',
    buttonText: 'Botão de texto',
    secondaryButtonBackground: 'Fundo do botão secundário',
    secondaryButtonText: 'Texto do Botão Secundário',
    pageBackground: 'Fundo da página',
    thisWorkoutIsCurrentlyExcludedFrom: 'Este exercício está atualmente excluído de {title}. Clique em <strong>Incluir</strong> para adicioná-lo de volta.',
    include: 'Incluir',
    activeCompetitions: 'Competições Ativas',
    eventDate: 'Data do evento',
    createdDate: 'Data de criação',
    owner: 'Proprietário',
    searchForACompetition: 'Procure uma competição',
    visitLandingPage: 'Visite a página inicial',
    orgFee: 'Org. Taxa',
    athFee: 'Ath. Taxa',
    athPays: 'Ath. Paga',
    scoringLinks: 'Links de pontuação',
    logs: 'Histórico',
    timestamp: 'Timestamp',
    user: 'Do utilizador',
    action: 'Açao',
    data: 'Dados',
    leaderboard: 'Entre os melhores',
    ties: 'Laços',
    athleteSubmitsScore: 'Atleta envia pontuação',
    platformFee: 'Taxa de plataforma',
    platformFeeDesc: 'A taxa de plataforma é um valor fixo na moeda da competição mais uma% da transação',
    currencyDesc: 'A moeda de toda a competição, incluindo a taxa fixa.',
    platformFeeFlatDesc: 'A taxa em número inteiro para {currency}. Para moedas decimais, como USD, na maioria das vezes será baseado multiplicado por 100 (por exemplo, $ 5 deve ser inserido como 500)',
    downloadScoringTemplate: 'Baixar modelo de pontuação',
    publishCompetition: 'Publicar competição',
    unpublishCompetition: 'Concurso de cancelamento de publicação',
    disableScheduling: 'Desativar programação',
    enableScheduling: 'Habilitar agendamento',
    disableSponsorship: 'Desativar patrocínio',
    enableSponsorship: 'Habilitar patrocínio',
    disableDevKit: 'Desativar Dev Kit',
    enableDevKit: 'Habilitar Dev Kit',
    disableRefunds: 'Desativar Reembolsos',
    enableRefunds: 'Habilitar Reembolsos',
    makeRegularComptition: 'Faça competição regular',
    makeATestCompetition: 'Faça uma competição de teste',
    enterEmail: 'Digite o e-mail',
    getActivationLink: 'Obtenha o link de ativação',
    processing: 'Em processamento...',
    rejected: 'Rejeitado',
    refunded: 'Devolveu',
    reverse: 'Marcha ré',
    refund: 'Reembolso',
    testError: 'Erro de teste',
    testRejection: 'Rejeição de teste',
    staffDashboard: 'Painel de controle da equipe',
    newUsers: 'Novos usuários',
    createdCompetitions: 'Competições criadas',
    refundRequests: 'Pedidos de reembolso',
    emailActivationLinks: 'Links de ativação de e-mail',
    youDoNotHavePermission: 'Parece que você não está autorizado a acessar isso.',
    ticketsNameDesc: 'Nome da pessoa que deve receber os ingressos.',
    ticketsEmailDesc: 'Email da pessoa que deve receber os ingressos.',
    details: 'Detalhes',
    yourRevenue: 'Sua receita',
    collectedFees: 'Taxas cobradas',
    transactions: 'Transações',
    nevermind: 'deixa pra lá',
    yesCancel: 'Sim cancele',
    notEnoughFunds: 'Recarregue a conta Stripe para reembolsar',
    all: 'Tudo',
    orLess: 'ou menos',
    enterRefundAmount: 'Insira um valor para reembolso.',
    refundHigherThanRevenue: 'Isso é mais do que a transação original por',
    tooMuch: 'Muito',
    deleteRegistrationAndPurchases: 'Exclua o registro e / ou compras.',
    whatDivisionsWillYouBeFeaturing: 'Quais divisões você estará apresentando?',
    whatDivisionsWillYouBeFeaturingDesc: 'Adicionamos alguns exemplos para você começar. Você pode arrastar & amp; elimine cada divisão para reordenar sua posição na lista.',
    purchasesDisabled: 'Compras desativadas',
    purchasesDisabledDesc: 'Atualmente, as compras estão desabilitadas. Por favor, tente novamente mais tarde.',
    addARegistration: 'Adicionar um registro',
    mustBeLoggedInForFeature: 'Você deve estar logado para este recurso.',
    scheduleHasntBeenPublished: 'A programação ainda não foi publicada.',
    heats: 'Aquece',
    mySchedule: 'Meu horário',
    stripeDashboard: 'Stripe Dashboard',
    chargesAreDisabled: 'As cobranças estão atualmente desativadas até que o problema com sua conta Stripe seja resolvido.',
    areYouSureYouWantToDeleteThat: 'Tem certeza que deseja excluir <strong>{that}</strong> ?',
    custom: 'Personalizado',
    editDay: 'Editar Dia',
    dayTitleDesc: 'O título do seu dia que será exibido na programação',
    dayDescriptionDesc: 'Conteúdo em rich text que será exibido na programação para este dia',
    whatDayIsThis: 'Que dia é hoje',
    editWorkoutLocation: 'Editar local de treino',
    addWorkoutLocation: 'Adicionar local de treino',
    pasteYourYouTubeUrl: 'Cole o seu URL do YouTube',
    country: 'País',
    searchForAnAthlete: 'Procure um atleta.',
    member: 'Membro',
    changeDivision: 'Divisão de Mudança',
    leaderboardPolicy: 'Política de classificação',
    leaderboardPolicyDesc: 'Selecione a política de pontuação que será usada para classificar as pontuações para a tabela de classificação desta divisão.',
    customPoints: 'Pontos Personalizados',
    customPointsDesc: 'Pontos delimitados por vírgulas, em ordem de colocação, para sua tabela de pontos personalizados.',
    leaderboardTiePolicy: 'Política de empate na tabela de classificação',
    leaderboardTiePolicyDesc: 'Selecione a política que será usada para desempatar na classificação geral desta tabela de classificação.',
  },

  dateTimeFormats: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },

  numberFormats: {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  }
};
